var map = {
	"./aca.png": 42528,
	"./acapulco/acapulco_1.jpg": 27280,
	"./acapulco/acapulco_2.jpg": 78396,
	"./acapulco/acapulco_3.jpg": 42936,
	"./acapulco/acapulco_4.jpg": 26652,
	"./acapulco/acapulco_5.jpg": 95776,
	"./acapulco/acapulco_6.jpg": 69540,
	"./acapulco/acapulco_7.jpg": 63376,
	"./acapulco/acapulco_8.jpg": 86048,
	"./acapulco/acapulco_9.jpg": 80628,
	"./acapulco/icono_1.svg": 90100,
	"./acapulco/icono_2.svg": 46944,
	"./acapulco/icono_3.svg": 79196,
	"./acapulco/icono_4.svg": 3160,
	"./acapulco/icono_5.svg": 64924,
	"./acapulco/prom-aca.jpeg": 53236,
	"./acapulco/videoSHORT.mp4": 20136,
	"./barrios/1.jpg": 36204,
	"./barrios/10.jpg": 43716,
	"./barrios/11.jpg": 32412,
	"./barrios/12.jpg": 39356,
	"./barrios/13.jpg": 59212,
	"./barrios/14.jpg": 52976,
	"./barrios/15.jpg": 95932,
	"./barrios/16.jpg": 36768,
	"./barrios/17.jpg": 67308,
	"./barrios/18.jpg": 88108,
	"./barrios/2.jpg": 96220,
	"./barrios/3.jpg": 97052,
	"./barrios/4.jpg": 7284,
	"./barrios/5.jpg": 69368,
	"./barrios/6.jpg": 63532,
	"./barrios/7.jpg": 4892,
	"./barrios/8.jpg": 52564,
	"./barrios/9.jpg": 34600,
	"./barrios/BM-Apizaco-Tlaxcala/1.jpg": 48020,
	"./barrios/BM-Apizaco-Tlaxcala/2.jpg": 82884,
	"./barrios/BM-Apizaco-Tlaxcala/3.jpg": 42848,
	"./barrios/BM-Apizaco-Tlaxcala/4.jpg": 96744,
	"./barrios/BM-Apizaco-Tlaxcala/5.jpg": 45796,
	"./barrios/BM-Barrio-Antiguo-de-Monterrey/3.jpg": 16740,
	"./barrios/BM-Barrio-Antiguo-de-Monterrey/4.jpg": 2288,
	"./barrios/BM-Barrio-Antiguo-de-Monterrey/5.jpg": 38556,
	"./barrios/BM-Barrio-Antiguo-de-Monterrey/6.jpg": 1388,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/1.jpg": 11380,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/10.jpg": 13760,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/11.jpg": 53764,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/12.jpg": 92084,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/13.jpg": 84268,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/14.jpg": 17712,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/15.jpg": 46576,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/16.jpg": 39088,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/17.jpg": 20660,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/18.jpg": 99992,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/19.jpg": 91172,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/2.jpg": 34308,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/20.jpg": 43776,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/21.jpg": 79348,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/3.jpg": 81548,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/4.jpg": 80127,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/5.jpg": 35063,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/6.jpg": 49972,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/7.jpg": 31092,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/8.jpg": 99928,
	"./barrios/BM-Barrio-de-Jalatlaco-Oaxaca/9.jpg": 16900,
	"./barrios/BM-Campeche/1.jpg": 93060,
	"./barrios/BM-Campeche/2.jpg": 55216,
	"./barrios/BM-Campeche/3.jpg": 19020,
	"./barrios/BM-Campeche/4.jpg": 20388,
	"./barrios/BM-Campeche/5.jpg": 87160,
	"./barrios/BM-Chetumal/1.jpg": 15088,
	"./barrios/BM-Chetumal/2.jpg": 13068,
	"./barrios/BM-Chetumal/3.jpg": 5068,
	"./barrios/BM-Chetumal/4.jpg": 94524,
	"./barrios/BM-Chetumal/5.jpg": 89476,
	"./barrios/BM-Chihuahua/1.jpg": 16364,
	"./barrios/BM-Chihuahua/2.jpg": 27516,
	"./barrios/BM-Chihuahua/3.jpg": 94072,
	"./barrios/BM-Chihuahua/4.jpg": 52844,
	"./barrios/BM-Chihuahua/5.jpg": 53608,
	"./barrios/BM-Chinesca/1.jpg": 79380,
	"./barrios/BM-Chinesca/1.png": 57956,
	"./barrios/BM-Chinesca/2.jpg": 45860,
	"./barrios/BM-Chinesca/3.jpg": 74676,
	"./barrios/BM-Chinesca/4.jpg": 52372,
	"./barrios/BM-Chinesca/5.jpg": 57008,
	"./barrios/BM-Jalatlaco/1.jpg": 87036,
	"./barrios/BM-Jalatlaco/2.jpg": 5116,
	"./barrios/BM-Jalatlaco/3.jpg": 98812,
	"./barrios/BM-Jalatlaco/4.jpg": 82007,
	"./barrios/BM-Jalatlaco/5.jpg": 8312,
	"./barrios/BM-La-Ermita-San-Sebastian-Xcalachen/1.jpg": 51204,
	"./barrios/BM-La-Ermita-San-Sebastian-Xcalachen/2.jpg": 92148,
	"./barrios/BM-La-Ermita-San-Sebastian-Xcalachen/3.jpg": 83928,
	"./barrios/BM-La-Ermita-San-Sebastian-Xcalachen/4.jpg": 79216,
	"./barrios/BM-La-Ermita-San-Sebastian-Xcalachen/5.jpg": 92820,
	"./barrios/BM-Michoacan/1.jpg": 71076,
	"./barrios/BM-Michoacan/2.jpg": 4596,
	"./barrios/BM-Michoacan/3.jpg": 48344,
	"./barrios/BM-Michoacan/4.jpg": 48604,
	"./barrios/BM-Michoacan/5.jpg": 37452,
	"./barrios/BM-Ocosingo-Chiapas/1.jpg": 91740,
	"./barrios/BM-Ocosingo-Chiapas/2.jpg": 58316,
	"./barrios/BM-Ocosingo-Chiapas/3.jpg": 8512,
	"./barrios/BM-Ocosingo-Chiapas/4.jpg": 97956,
	"./barrios/BM-Ocosingo-Chiapas/5.jpg": 72468,
	"./barrios/BM-San-Luis/1.jpg": 50916,
	"./barrios/BM-San-Luis/2.jpg": 68296,
	"./barrios/BM-San-Luis/3.jpg": 2256,
	"./barrios/BM-San-Luis/4.jpg": 22020,
	"./barrios/BM-San-Luis/5.jpg": 59604,
	"./barrios/BM-Sonora/1.jpg": 63252,
	"./barrios/BM-Sonora/2.jpg": 85316,
	"./barrios/BM-Sonora/3.jpg": 46196,
	"./barrios/BM-Sonora/4.jpg": 91828,
	"./barrios/BM-Sonora/5.jpg": 10256,
	"./barrios/BM-Veracruz/1.jpg": 10916,
	"./barrios/BM-Veracruz/2.jpg": 29420,
	"./barrios/BM-Veracruz/3.jpg": 57460,
	"./barrios/BM-Veracruz/4.jpg": 63580,
	"./barrios/BM-Veracruz/5.jpg": 30231,
	"./barrios/heroslide_1.jpg": 46124,
	"./barrios/heroslide_2.jpg": 38656,
	"./barrios/heroslide_3.jpg": 79752,
	"./barrios/heroslide_4.jpg": 66016,
	"./barrios/heroslide_5.jpg": 60556,
	"./barrios/heroslide_6.jpg": 32708,
	"./barrios/heroslide_7.jpg": 99024,
	"./barrios/heroslide_8.jpg": 28348,
	"./barrios/img_guiaturistica/GRO_acapulco.webp": 68280,
	"./barrios/img_guiaturistica/GTO.webp": 16211,
	"./barrios/img_guiaturistica/Jguadalajara.webp": 30216,
	"./barrios/img_guiaturistica/campeche.jpg": 96452,
	"./barrios/img_guiaturistica/cancun.webp": 1504,
	"./barrios/img_guiaturistica/cdmx.jpg": 19656,
	"./barrios/img_guiaturistica/chiapas.jpg": 88252,
	"./barrios/img_guiaturistica/maya.webp": 27760,
	"./barrios/logo.jpg": 67324,
	"./blog/COZUMEL-0308.jpg": 89056,
	"./blog/COZUMEL-Bicicleta.jpg": 37072,
	"./blog/COZUMEL_buzo.jpg": 88355,
	"./blog/DIA-DE-MUERTOS-INFLUENCER_05.webp": 198,
	"./blog/ESFERA-ARTESANAL.jpg": 33488,
	"./blog/Fondo amarillo 4.png": 11084,
	"./blog/Vidrio-Soplado.jpg": 82800,
	"./blog/cover_blog.jpg": 92164,
	"./blog/esferas.jpg": 4492,
	"./blog/esferas.png": 86504,
	"./blog/manoEsferas.png": 12580,
	"./blog/principal.jpg": 91392,
	"./blog/titulo-cozumel.jpg": 91104,
	"./blog/volcan.png": 72884,
	"./calendario/ChiapasBirdingandPhotoFestivalAvesBocArista.webp": 41586,
	"./calendario/ComalaColmaFestividadesFeriaPanPoncheyCafe.webp": 14072,
	"./calendario/Comala_-Colima.webp": 24384,
	"./calendario/ElPandelaCatrina.webp": 7336,
	"./calendario/ElPandelaCatrina2.webp": 68500,
	"./calendario/FeriaDeTodosLosSantos2023.webp": 76128,
	"./calendario/FestivaldeLas_Calaveras.webp": 29840,
	"./calendario/FiestaGrandeChiapaCorzo.webp": 75384,
	"./calendario/FullMoonLoreto2023.webp": 3832,
	"./calendario/ManzanilloSeIlumina.webp": 9568,
	"./calendario/MarAMar.webp": 65142,
	"./calendario/PetalosdeRosa.webp": 9392,
	"./calendario/TSL-LOGO.png": 89088,
	"./calendario/TapijulapaTabasco.webp": 67952,
	"./calendario/TaxcoGuerrero2.webp": 5784,
	"./calendario/TaxcoGuerreroIglesiaOK.webp": 43832,
	"./calendario/calendarioAzteca.webp": 27860,
	"./calendario/catrina.webp": 83256,
	"./calendario/chiapas-photo-portada.webp": 33980,
	"./calendario/diaMuertos.webp": 52272,
	"./calendario/diaMuertos4.webp": 99624,
	"./calendario/diaMuertos5.webp": 25968,
	"./calendario/diaMuertos6.webp": 60080,
	"./calendario/evento_bg.jpg": 40684,
	"./calendario/festivalCalaverasAguascalientes.webp": 23402,
	"./calendario/festivalChocolate.webp": 65864,
	"./calendario/festivalHistoricoCampeche.webp": 92708,
	"./calendario/festivalRevueltas.webp": 2552,
	"./calendario/lago-patzcuaro.webp": 20555,
	"./calendario/ofrendas.jpg": 79388,
	"./calendario/saltillo.webp": 41072,
	"./calendario/vendimiaAguascalientes.webp": 68724,
	"./calendario/vendimia_Mesa-de-trabajo-1.webp": 64038,
	"./ciudades-patrimonio/carrusel/campeche.jpg": 55264,
	"./ciudades-patrimonio/carrusel/campeche.png": 49000,
	"./ciudades-patrimonio/carrusel/cdmx.jpg": 18972,
	"./ciudades-patrimonio/carrusel/cdmx.png": 41176,
	"./ciudades-patrimonio/carrusel/durango.jpg": 17340,
	"./ciudades-patrimonio/carrusel/durango.png": 39544,
	"./ciudades-patrimonio/carrusel/guanajuato.jpg": 43592,
	"./ciudades-patrimonio/carrusel/guanajuato.png": 44996,
	"./ciudades-patrimonio/carrusel/morelia.jpg": 22648,
	"./ciudades-patrimonio/carrusel/morelia.png": 30176,
	"./ciudades-patrimonio/carrusel/oaxaca.jpg": 41820,
	"./ciudades-patrimonio/carrusel/oaxaca.png": 66060,
	"./ciudades-patrimonio/carrusel/puebla.jpg": 1612,
	"./ciudades-patrimonio/carrusel/puebla.png": 82292,
	"./ciudades-patrimonio/carrusel/queretaro.jpg": 32092,
	"./ciudades-patrimonio/carrusel/queretaro.png": 95416,
	"./ciudades-patrimonio/carrusel/san-juan.jpg": 23728,
	"./ciudades-patrimonio/carrusel/san-juan.png": 21164,
	"./ciudades-patrimonio/carrusel/san-luis.jpg": 98684,
	"./ciudades-patrimonio/carrusel/san-luis.png": 14156,
	"./ciudades-patrimonio/carrusel/san-miguel.jpg": 20332,
	"./ciudades-patrimonio/carrusel/san-miguel.png": 2344,
	"./ciudades-patrimonio/carrusel/snluis.jpg": 6480,
	"./ciudades-patrimonio/carrusel/tlacotalpan.jpg": 51504,
	"./ciudades-patrimonio/carrusel/tlacotalpan.png": 75940,
	"./ciudades-patrimonio/carrusel/xochimilco.jpg": 87293,
	"./ciudades-patrimonio/carrusel/xochimilco.png": 63116,
	"./ciudades-patrimonio/carrusel/zacatecas.jpg": 31856,
	"./ciudades-patrimonio/carrusel/zacatecas.png": 82468,
	"./ciudades-patrimonio/galeria1.jpg": 34864,
	"./ciudades-patrimonio/galeria1.png": 27972,
	"./ciudades-patrimonio/galeria2.jpg": 84064,
	"./ciudades-patrimonio/galeria2.png": 6228,
	"./ciudades-patrimonio/galeria3.jpeg": 73744,
	"./ciudades-patrimonio/galeria3.jpg": 17596,
	"./ciudades-patrimonio/galeria3.png": 41644,
	"./ciudades-patrimonio/hero.jpg": 42348,
	"./ciudades-patrimonio/hero.png": 58120,
	"./ciudades-patrimonio/imagen_1.png": 5536,
	"./ciudades-patrimonio/logo.jpg": 51952,
	"./descargas/AGS_Aguascalientes_MuseoDeLaMuerte-36.jpg": 79576,
	"./descargas/AGS_Museo_muerte_38.jpg": 13892,
	"./descargas/AGS_Museo_muerte_51.jpg": 97780,
	"./descargas/AGS_aguascalientes_146.jpg": 93988,
	"./descargas/AGS_aguascalientes_153.jpg": 18068,
	"./descargas/AGS_aguascalientes_164.jpg": 28536,
	"./descargas/AGS_aguascalientes_166.jpg": 37916,
	"./descargas/AGS_aguascalientes_209.jpg": 20784,
	"./descargas/AGS_aguascalientes_236.jpg": 65324,
	"./descargas/AGS_aguascalientes_261.jpg": 312,
	"./descargas/AGS_aguascalientes_400.jpg": 42803,
	"./descargas/AGS_aguascalientes_411.jpg": 66672,
	"./descargas/AGS_aguascalientes_43.jpg": 14912,
	"./descargas/AGS_aguascalientes_482.jpg": 48460,
	"./descargas/AGS_aguascalientes_495.jpg": 4956,
	"./descargas/AGS_aguascalientes_708.jpg": 40640,
	"./descargas/AGS_aguascalientes_71.jpg": 38672,
	"./descargas/AGS_asientos_113.jpg": 46160,
	"./descargas/AGS_asientos_51.jpg": 48596,
	"./descargas/AGS_asientos_78.jpg": 61780,
	"./descargas/AGS_cristo_25.jpg": 47444,
	"./descargas/AGS_penuelas_28.jpg": 75308,
	"./descargas/AGS_plaza_de_toros_402.jpg": 39588,
	"./descargas/Boca_de_Tunel_Aguascalientes.jpeg": 27784,
	"./descargas/Catedral-de-Zacatecas.jpg": 76476,
	"./descargas/Centro-Colima.jpg": 54684,
	"./descargas/Centro_Historico_de_Aguascalientes_Aguascalientes.jpeg": 93156,
	"./descargas/Cerro-de-la-Bufa-Zacatecas.jpg": 5420,
	"./descargas/Corredor-Centro-Colima.jpg": 19836,
	"./descargas/DESTINO DEL MES - SINALOA EN CHINO.mp4": 55020,
	"./descargas/Edificio_Municipal_de_Aguascalientes_Aguascalientes.jpeg": 37732,
	"./descargas/El_Garruno_Aguascalientes.jpeg": 45160,
	"./descargas/Escolleras-de-las-Brisas-Manzanilo-Colima.jpg": 76884,
	"./descargas/Fabrica-de-Ron-Comala-Colima.jpg": 18644,
	"./descargas/Hotel-Quinta-Real-y-Acueducto-el-Cubo.jpg": 99639,
	"./descargas/Iglesia-Centro-de-Colima.jpg": 82804,
	"./descargas/Laguna-La-Maria-Comala-Colima.jpg": 42364,
	"./descargas/Laguna-Xolopan-Manzanillo-Colima.jpg": 82916,
	"./descargas/Museo_Padre_Nieves_Aguascalientes.jpeg": 10500,
	"./descargas/Museo_de_Historia_Cultural_de_Rincon_de_Romos_Aguascalientes.jpeg": 42804,
	"./descargas/Pabellon-de-Hidalgo-Aguascalientes.mp4": 43256,
	"./descargas/Platillos-tipicos-Colima.jpg": 34528,
	"./descargas/Playa-La-Audiencia-Manzanillo-Colima.jpg": 47984,
	"./descargas/Plaza_Patria_Ciudad_de_Aguascalientes.jpeg": 73804,
	"./descargas/Presa_Plutarco_Elias_Calles_Aguascalientes.jpeg": 72996,
	"./descargas/Presa_de_Malpaso_Sierra_del_Laurel_Aguascalientes.jpeg": 51212,
	"./descargas/Rancho_Cinegetico_Torrecillas_Aguascalientes.jpeg": 15360,
	"./descargas/San_Jose_de_Gracia_Aguascalientes.jpeg": 47196,
	"./descargas/Santuario_del_Cristo_Roto_Aguascalientes.jpeg": 62468,
	"./descargas/Sierra_de_Laurel_Aguascalientes.jpeg": 94136,
	"./descargas/Teatro-Hidalgo-Centro-de-Colima.jpg": 76516,
	"./descargas/Templo_de_San_Marcos_Aguascalientes.jpeg": 13312,
	"./descargas/Tirolesa-Zacatecas.jpg": 62927,
	"./descargas/acapulco-el-sol-te-llama.jpg": 92384,
	"./descargas/acapulco-guerrero.jpeg": 53052,
	"./descargas/acoxochitlan-hidalgo.jpeg": 83244,
	"./descargas/acueducto-de-morelia-michoacan.jpeg": 332,
	"./descargas/aculco-estado-de-mexico-1.jpeg": 75576,
	"./descargas/aculco-estado-de-mexico.jpeg": 95784,
	"./descargas/agua-de-barranca-tipica-de-tlaxcala-tlaxcala.jpeg": 72864,
	"./descargas/aguas_1.webp": 42710,
	"./descargas/aguas_2.webp": 66600,
	"./descargas/aguas_3.avif": 93016,
	"./descargas/aguas_4.jpg": 17732,
	"./descargas/aguas_5.jpg": 77696,
	"./descargas/aguas_6.jpg": 24156,
	"./descargas/aguas_7.webp": 70908,
	"./descargas/aguascalientes-hero.jpg": 46020,
	"./descargas/ajijic-jalisco.jpeg": 43708,
	"./descargas/alamos-sonora.jpeg": 37600,
	"./descargas/aldama-tamaulipas.jpeg": 9676,
	"./descargas/alfareria-en-tlaquepaque-jalisco.jpeg": 93992,
	"./descargas/alpha.jpg": 87212,
	"./descargas/amanecer-puerto-veracruz-veracruz.jpeg": 23932,
	"./descargas/amealco-gastronomia-queretaro.jpeg": 81984,
	"./descargas/andador-eclesiastico-san-cristobal-de-las-casas-chiapas.jpeg": 61732,
	"./descargas/angangueo-michoacan-1.jpeg": 1064,
	"./descargas/angangueo-michoacan.jpeg": 17724,
	"./descargas/angostura-sinaloa.jpeg": 64312,
	"./descargas/antigua-aduana-tampico-tamaulipas.jpeg": 37124,
	"./descargas/antigua-estacion-del-tren-en-ciudad-de-queretaro.jpeg": 60184,
	"./descargas/antigua-fabrica-de-sal-viesca-coahuila.jpeg": 1992,
	"./descargas/antigua-iglesia-de-san-juan-parangaricutiro-michoacan.jpeg": 14928,
	"./descargas/arco-de-leon-leon-guanajuato.jpeg": 56247,
	"./descargas/arcos-zempoala-hidalgo.jpeg": 48456,
	"./descargas/arpista-jarocho-en-veracruz.jpeg": 77428,
	"./descargas/arte-forjado-en-hierro-michoacan.jpeg": 79904,
	"./descargas/artesana-de-tlayacapan-morelos.jpeg": 87236,
	"./descargas/artesanias-de-campeche.jpeg": 39388,
	"./descargas/artesanias-de-cobre-en-michoacan.jpeg": 63772,
	"./descargas/artesanias-metepec-estado-de-mexico.jpeg": 71388,
	"./descargas/asado-de-boda-platillo-tipico-de-zacatecas.jpeg": 57144,
	"./descargas/atardecer-en-la-costa-de-acapulco.jpg": 25091,
	"./descargas/atardecer-en-zicatela-oaxaca.jpeg": 53552,
	"./descargas/atardecer-lago-de-cuitzeo-michoacan.jpeg": 72228,
	"./descargas/atardecer-vallarta-jalisco.jpeg": 66932,
	"./descargas/atil-sonora.jpeg": 30588,
	"./descargas/atlantes-de-tula-hidalgo.jpeg": 49388,
	"./descargas/atlatlahucan-morelos.jpeg": 13564,
	"./descargas/axtla-de-terrazas-san-luis-potosi.jpeg": 5616,
	"./descargas/ayuntamiento-de-merida-yucatan.jpeg": 59740,
	"./descargas/ayuntamiento-de-tlaxcala-tlaxcala.jpeg": 5516,
	"./descargas/bahia-chahue-oaxaca.jpeg": 25836,
	"./descargas/bahia-de-acapulco-guerrero-1.jpeg": 30872,
	"./descargas/bahia-de-acapulco-guerrero.jpeg": 82616,
	"./descargas/bahia-de-kino-sonora-1.jpeg": 31148,
	"./descargas/bahia-de-kino-sonora.jpeg": 41620,
	"./descargas/bahia-magdalena-baja-california-sur-1.jpeg": 41680,
	"./descargas/bahia-magdalena-baja-california-sur.jpeg": 20348,
	"./descargas/baja-california-sur-mexico-destino-del-mes-aleman.mp4": 30020,
	"./descargas/baja-california-sur-mexico-destino-del-mes-chino.mp4": 22652,
	"./descargas/baja-california-sur-mexico-destino-del-mes-frances.mp4": 48180,
	"./descargas/baja-california-sur-mexico-destino-del-mes-italiano.mp4": 30284,
	"./descargas/baja-california-sur-mexico-destino-del-mes-japones.mp4": 34368,
	"./descargas/baja-california-sur-mexico-destino-del-mes-portugues.mp4": 44988,
	"./descargas/baja-california-sur-mexico-destino-del-mes.mp4": 15120,
	"./descargas/balamku-campeche.jpeg": 85372,
	"./descargas/baluarte-de-san-juan-campeche-campeche.jpeg": 81128,
	"./descargas/baluarte-de-san-juan-campeche.jpeg": 81228,
	"./descargas/baluarte-san-carlos-campeche-campeche.jpeg": 14120,
	"./descargas/barbacoa-de-hidalgo.jpeg": 94352,
	"./descargas/barra-vieja-guerrero.jpeg": 83520,
	"./descargas/barranca-de-los-jilgueros-puebla.jpeg": 54352,
	"./descargas/barranca-del-cobre-chihuahua.jpeg": 3560,
	"./descargas/barrio-antiguo-monterrey-nuevo-leon.jpeg": 20500,
	"./descargas/barrio-magico-la-chinesca-mexicali-baja-california.jpg": 59400,
	"./descargas/batopilas-chihuahua.jpeg": 39864,
	"./descargas/bcn_1.jpg": 64028,
	"./descargas/bcn_2.webp": 70912,
	"./descargas/bcn_3.jpg": 48028,
	"./descargas/bcn_4.webp": 27868,
	"./descargas/bcn_5.webp": 99520,
	"./descargas/bcn_6.jpg": 8644,
	"./descargas/bcs_1.webp": 66168,
	"./descargas/becal-campeche.jpeg": 87120,
	"./descargas/biosfera-el-cielo-tamaulipas.jpeg": 3356,
	"./descargas/boca-de-potrerillos-nuevo-leon.jpeg": 19456,
	"./descargas/bosque-de-maple-en-talpa-jalisco.jpeg": 82968,
	"./descargas/bosques-de-bambu-en-teziutlan.jpeg": 8704,
	"./descargas/bosques-de-monterreal-arteaga-coahuila.jpeg": 53968,
	"./descargas/buceo-en-cozumel-quintana-roo.jpeg": 83656,
	"./descargas/buceo-en-quintana-roo.jpeg": 26508,
	"./descargas/cabanas-en-mineral-del-monte-hidalgo.jpeg": 92576,
	"./descargas/caborca-sonora.jpeg": 15416,
	"./descargas/cafe-con-leche-tradicional-en-veracruz.jpeg": 30404,
	"./descargas/calakmul-zona-arqueologica-campeche.jpeg": 23844,
	"./descargas/caldo-de-camaron-en-nayarit.jpeg": 73272,
	"./descargas/calle-59-campeche.jpeg": 14792,
	"./descargas/calle-de-aldama-san-miguel-allende-guanajuato.jpeg": 13960,
	"./descargas/callejon-de-los-sapos-puebla.jpeg": 27500,
	"./descargas/callejon-del-beso-guanajuato-guanajuato.jpeg": 892,
	"./descargas/callejoneada-guanajuato.jpeg": 14248,
	"./descargas/calles-de-campeche-campeche.jpeg": 25548,
	"./descargas/calles-del-centro-de-cuernavaca-morelos.jpeg": 17548,
	"./descargas/calles-empedradas-mineral-del-monte-hidalgo.jpeg": 3048,
	"./descargas/calles-en-san-miguel-de-allende-guanajuato.jpeg": 77096,
	"./descargas/calzada-de-los-muertos-zona-arqueologica-teotihuacan-estado-de-mexico.jpeg": 48284,
	"./descargas/calzado-en-estado-de-mexico-1.jpeg": 87756,
	"./descargas/calzado-en-estado-de-mexico.jpeg": 96640,
	"./descargas/campeche_1.jpg": 45388,
	"./descargas/campos-de-tlayacapan-morelos.jpeg": 19596,
	"./descargas/canon-del-sumidero-chiapas.jpeg": 77072,
	"./descargas/canto-del-bosque-santuario-de-las-luciernagas-nanacamilpa-tlaxcala.jpeg": 52856,
	"./descargas/capilla-abierta-de-parroquia-de-todos-santos-zempoala-hidalgo.jpeg": 85092,
	"./descargas/capilla-de-xochitepec-morelos.jpeg": 91792,
	"./descargas/capilla-magdalena-tacambaro-michoacan.jpeg": 45608,
	"./descargas/capilla-nuestra-senora-del-rosario-puebla.jpeg": 73916,
	"./descargas/capulalpam-de-mendez-oaxaca.jpeg": 51516,
	"./descargas/carnaval-de-tlaltizapan-de-zapata-morelos.jpeg": 42412,
	"./descargas/casa-de-la-corregidora-queretaro.jpeg": 31676,
	"./descargas/casa-de-los-azulejos-tabasco.jpeg": 24180,
	"./descargas/casa-jure-merida-yucatan.jpeg": 66052,
	"./descargas/casa-museo-jose-alfredo-jimenez-dolores-hidalgo-guanajuato.jpeg": 76928,
	"./descargas/cascada-chimalapa-acaxotitlan-hidalgo.jpeg": 10300,
	"./descargas/cascada-chuveje-sierra-gorda-queretaro.jpeg": 2624,
	"./descargas/cascada-de-dos-mundos-acaxotitlan-hidalgo.jpeg": 82948,
	"./descargas/cascada-de-la-monja-xico-veracruz.jpeg": 67828,
	"./descargas/cascada-de-tamul-san-luis-potosi-1.jpeg": 55896,
	"./descargas/cascada-de-tamul-san-luis-potosi.jpeg": 15580,
	"./descargas/cascada-el-salto-san-luis-potosi.jpg": 51840,
	"./descargas/cascada-el-salto-zaragoza-nuevo-leon.jpeg": 18372,
	"./descargas/cascada-maravillas-san-joaquin-queretaro.jpeg": 3244,
	"./descargas/cascada-totolapa-puebla.jpeg": 14124,
	"./descargas/cascada-velo-de-novia-valle-de-bravo-estado-de-mexico.jpeg": 32860,
	"./descargas/cascadas-del-circuito-de-la-niebla-en-teziutlan.jpeg": 78928,
	"./descargas/cascadas-el-meco-aquismon-san-luis-potosi.jpeg": 23612,
	"./descargas/cascadas-magicas-de-copalitilla-oaxaca.jpeg": 32840,
	"./descargas/catedral-basilica-menor-colima-colima.jpeg": 26632,
	"./descargas/catedral-de-cuernavaca-morelos.jpeg": 24412,
	"./descargas/catedral-de-la-asuncion-ex-convento-franciscano-tlaxcala.jpeg": 47412,
	"./descargas/catedral-de-leon-guanajuato.jpeg": 14904,
	"./descargas/catedral-de-merida-yucatan.jpeg": 34736,
	"./descargas/catedral-de-morelia-michoacan.jpeg": 37388,
	"./descargas/catedral-de-nuestra-senora-de-la-asuncion-tlaxcala-tlaxcala.jpeg": 91924,
	"./descargas/catedral-de-san-cristobal-martir-chiapas.jpeg": 93380,
	"./descargas/catedral-metropolitana-ciudad-de-mexico.jpeg": 44008,
	"./descargas/catedral-metropolitana-de-oaxaca-oaxaca.jpeg": 95056,
	"./descargas/catedral-metropolitana-san-luis-potosi.jpg": 36288,
	"./descargas/catedral-nuestra-senora-de-guadalupe-ciudad-juarez-chihuahua.jpeg": 8002,
	"./descargas/caverna-los-cuarteles-tamaulipas.jpeg": 51448,
	"./descargas/cenote-cocodrilo-dorado-quintana-roo.jpeg": 83800,
	"./descargas/cenote-en-yucatan.jpeg": 30700,
	"./descargas/cenote-hacienda-mucuyche-yucatan.jpeg": 77568,
	"./descargas/cenote-maya-park-yucatan.jpeg": 91880,
	"./descargas/cenote-xkeken-valladolid-yucatan.jpeg": 88968,
	"./descargas/cenotes-miguel-colorado-champoton-campeche.jpeg": 91154,
	"./descargas/centla-tabasco.jpeg": 41303,
	"./descargas/centro-capital-durango.jpeg": 32208,
	"./descargas/centro-cultural-quinta-gameros-chihuahua.jpeg": 55212,
	"./descargas/centro-de-la-ciudad-de-chihuahua-chihuahua.jpeg": 10112,
	"./descargas/centro-de-santa-rosalia-baja-california.jpg": 95552,
	"./descargas/centro-historico-campeche.jpeg": 98476,
	"./descargas/centro-historico-de-la-ciudad-de-puebla.jpeg": 77144,
	"./descargas/centro-historico-de-noche-zacatecas.jpeg": 31924,
	"./descargas/centro-historico-de-puebla.jpeg": 85787,
	"./descargas/centro-historico-zacatecas.jpeg": 38088,
	"./descargas/centro-municipal-de-las-artes-en-chihuahua.jpeg": 1448,
	"./descargas/centro-saltillo-coahuila.jpeg": 79964,
	"./descargas/centro-villa-del-carbon-estado-de-mexico.jpeg": 25112,
	"./descargas/cerro-de-la-bufa-zacatecas-1.jpeg": 21200,
	"./descargas/cerro-de-la-bufa-zacatecas.jpeg": 98104,
	"./descargas/cerro-de-la-mascara-sinaloa.jpeg": 22392,
	"./descargas/cerro-de-la-silla-nuevo-leon.jpeg": 52020,
	"./descargas/charrerias-jalisco.jpeg": 53988,
	"./descargas/chepe-express-sinaloa.jpeg": 56316,
	"./descargas/chichen-itza-yucatan.jpeg": 28023,
	"./descargas/cieneguilla-morelos.jpeg": 30724,
	"./descargas/ciudad-madero-playa-miramar-tampico.jpeg": 38788,
	"./descargas/coatetelco-morelos.jpeg": 60020,
	"./descargas/cochinita-pibil-yucateca.jpeg": 91332,
	"./descargas/cocorit-sonora-1.jpeg": 89104,
	"./descargas/cocorit-sonora.jpeg": 58364,
	"./descargas/coctel-de-yucatan.jpeg": 43820,
	"./descargas/coctel-en-el-lago-de-tequesquitengo.jpeg": 57940,
	"./descargas/cocula-la-cuna-del-mariachi.jpeg": 17104,
	"./descargas/cola-de-caballo-nuevo-leon.jpeg": 61800,
	"./descargas/comala-colima.jpeg": 23172,
	"./descargas/comida-en-el-lago-de-tequesquitengo.jpeg": 28944,
	"./descargas/comida-tipica-de-guanajuato.jpeg": 19607,
	"./descargas/comida-tipica-meztitlan-hidalgo.jpeg": 31492,
	"./descargas/comonfort-guanajuato.jpeg": 67924,
	"./descargas/concordia-copala-sinaloa.jpeg": 88308,
	"./descargas/convento-de-los-santos-reyes-meztitlan-hidalgo.jpeg": 23072,
	"./descargas/convento-de-san-antonio-de-padua-izamal-yucatan.jpeg": 93728,
	"./descargas/cosala-sinaloa.jpeg": 51328,
	"./descargas/cosmovitral-jardin-botanico-estado-de-mexico.jpeg": 35804,
	"./descargas/costa-alegre-jalisco.jpeg": 70388,
	"./descargas/costa-oaxaca-oaxaca.jpeg": 28584,
	"./descargas/cristo-rey-del-cubilete-en-silao-guanajuato.jpeg": 23300,
	"./descargas/cuatrimotos-parque-natural-mexiquillo-durango.jpeg": 1407,
	"./descargas/cuevas-con-arte-rupestre-choix-sinaloa-1.jpeg": 74288,
	"./descargas/cuevas-con-arte-rupestre-choix-sinaloa.jpeg": 82296,
	"./descargas/cuevas-mantezulel-aquismon-san-luis-potosi.jpeg": 83464,
	"./descargas/danzantes-chinelos-axochiapan-morelos.jpeg": 55756,
	"./descargas/delfin-en-aguas-de-loreto-baja-california-sur.jpeg": 26412,
	"./descargas/destino-del-mes-aguascalientes.mp4": 39100,
	"./descargas/destino-del-mes-bacalar-quintana-roo.mp4": 96984,
	"./descargas/destino-del-mes-cdmx.mp4": 71068,
	"./descargas/destino-del-mes-estado-de-jalisco.mp4": 77540,
	"./descargas/destino-del-mes-estado-de-morelos.mp4": 59396,
	"./descargas/destino-del-mes-izamral-yucatan.mp4": 80588,
	"./descargas/destino-del-mes-san-cristobal-de-las-casas-chiapas.mp4": 77412,
	"./descargas/destino-del-mes-sinaloa-aleman.mp4": 69080,
	"./descargas/destino-del-mes-sinaloa-en-chino.mp4": 64804,
	"./descargas/destino-del-mes-sinaloa-frances.mp4": 89996,
	"./descargas/destino-del-mes-sinaloa-ingles.mp4": 21972,
	"./descargas/destino-del-mes-sinaloa-italiano.mp4": 47228,
	"./descargas/destino-del-mes-sinaloa-japones.mp4": 55228,
	"./descargas/destino-del-mes-sinaloa-portugues.mp4": 82704,
	"./descargas/destino-del-mes-tlaxcala.mp4": 99940,
	"./descargas/destino-del-mes-veracruz.mp4": 9800,
	"./descargas/dia-de-muertos-en-hanal-pixan-campeche.jpeg": 71880,
	"./descargas/disfrutando-el-lago-de-tequesquitengo.jpeg": 51384,
	"./descargas/dolores-hidalgo-guanajuato.jpeg": 47752,
	"./descargas/dulces-tipicos-de-jalisco.jpeg": 53084,
	"./descargas/dulces-tradicionales-parras-coahuila.jpeg": 74444,
	"./descargas/dunas-de-altamura-bahia-santa-maria-angostura-sinaloa.jpeg": 60836,
	"./descargas/dunas-de-bilbao-coahuila.jpeg": 94864,
	"./descargas/dunas-de-bilbao-viesca-coahuila.jpeg": 62940,
	"./descargas/dunas-de-samalayuca-chihuahua.jpeg": 6651,
	"./descargas/dunas-de-yeso-coahuila.jpeg": 37672,
	"./descargas/edificio-mercedes-tampico-tamaulipas.jpeg": 23896,
	"./descargas/el-angel-de-la-independencia-cdmx.jpeg": 85584,
	"./descargas/el-beaterio-colima.jpeg": 4648,
	"./descargas/el-caballito-de-tolsa-afuera-del-munal-ciudad-de-mexico.jpeg": 95572,
	"./descargas/el-danzante-conchero-chichimeca-santiago-de-queretaro.jpeg": 39464,
	"./descargas/el-fuerte-sinaloa-1.jpeg": 98560,
	"./descargas/el-fuerte-sinaloa.jpeg": 33848,
	"./descargas/el-palacio-de-justicia-o-antigua-capilla-real-de-indios-tlaxcala-tlaxcala.jpeg": 59488,
	"./descargas/el-pozo-del-gavilan-nuevo-leon.jpeg": 33600,
	"./descargas/el-salto-durango.jpeg": 38891,
	"./descargas/el-vigilante-zimapan-hidalgo.jpeg": 34212,
	"./descargas/el-zacaton-cenotes-tamaulipas.jpeg": 78264,
	"./descargas/ensalada-de-camaron-en-veracruz.jpeg": 75584,
	"./descargas/entrada-a-la-hacienda-de-san-antonio-colima.jpeg": 39076,
	"./descargas/entrada-al-palacio-de-bellas-artes-en-ciudad-de-mexico.jpeg": 22450,
	"./descargas/escalada-cascada-de-basaseachi-chihuahua.jpeg": 17916,
	"./descargas/escultura-del-museo-de-arte-de-tlaxcala-tlaxcala.jpeg": 5496,
	"./descargas/estatua-de-emiliano-zapata.jpeg": 10364,
	"./descargas/ex-hacienda-del-carmen-salvatierra-guanajuato.jpeg": 50352,
	"./descargas/exconvento-de-san-francisco-tlaxcala.jpeg": 16584,
	"./descargas/exconvento-yuriria-guanajuato.jpeg": 31112,
	"./descargas/exterior-cenote-hacienda-mucuyche-yucatan.jpeg": 68520,
	"./descargas/faro-de-punta-cancun-quintana-roo.jpeg": 50572,
	"./descargas/fauna-del-parque-el-tecuan-durango.jpeg": 49856,
	"./descargas/festival-de-la-luz-y-la-vida-en-puebla.jpeg": 16136,
	"./descargas/festival-del-globo-leon-guanajuato.jpeg": 316,
	"./descargas/fiestas-patrias-hidalgo.jpeg": 46060,
	"./descargas/foro-boca-boca-del-rio-veracruz.jpeg": 9368,
	"./descargas/fresas-de-irapuato-guanajuato.jpeg": 82280,
	"./descargas/fuente-de-la-aguadora-jiquilpan-de-juarez-michoacan.jpeg": 38948,
	"./descargas/fuente-toptli-en-cosala-sinaloa.jpeg": 77600,
	"./descargas/fuerte-de-san-jose-el-alto-campeche.jpeg": 96732,
	"./descargas/gastronomia-michoacan.jpeg": 79080,
	"./descargas/gastronomia-sinaloa.jpeg": 43136,
	"./descargas/gastronomia-tamaulipas.jpeg": 90724,
	"./descargas/gastronomia-teziuteca.jpeg": 15564,
	"./descargas/gastronomia-tradicional-oaxaquena.jpeg": 11240,
	"./descargas/gastronomia-yucateca.jpeg": 27352,
	"./descargas/glorieta-de-la-minerva-guadalajara-jalisco.jpeg": 24820,
	"./descargas/glorieta-del-corazon-mazatlan-sinaloa.jpeg": 29212,
	"./descargas/gomez-farias-biosfera-el-cielo-tamaulipas.jpeg": 57292,
	"./descargas/grutas-de-acocomoca-tetela-de-ocampo.jpeg": 37063,
	"./descargas/grutas-de-bustamante-nuevo-leon.jpeg": 36220,
	"./descargas/grutas-de-la-estrella-tonatico-estado-de-mexico-1.jpeg": 57624,
	"./descargas/grutas-de-la-estrella-tonatico-estado-de-mexico.jpeg": 60983,
	"./descargas/hacienda-de-soltepec-tlaxcala.jpeg": 37668,
	"./descargas/hacienda-fiesta-americana-en-xochitepec-morelos.jpeg": 27884,
	"./descargas/hacienda-mucuyche-yucatan.jpeg": 88508,
	"./descargas/hacienda-san-diego-tlalayote-hidalgo.jpeg": 99620,
	"./descargas/hacienda-san-gabriel-de-las-palmas-morelos.jpeg": 63284,
	"./descargas/hacienda-santa-maria-regla-hidalgo-1.jpeg": 92044,
	"./descargas/hacienda-santa-maria-regla-hidalgo.jpeg": 21816,
	"./descargas/hacienda-temixco-morelos.jpeg": 81816,
	"./descargas/hacienda-yaxcopoil-yucatan.jpeg": 81064,
	"./descargas/hecelchakan-campeche.jpeg": 86180,
	"./descargas/hermosillo-sonora.jpeg": 42352,
	"./descargas/hero.jpg": 45764,
	"./descargas/hero.webp": 77160,
	"./descargas/higueras-nuevo-leon.jpeg": 25616,
	"./descargas/hoteles-zona-dorada-de-acapulco.jpg": 76276,
	"./descargas/huejotzingo-puebla-pueblos-magicos.mp4": 42328,
	"./descargas/iglesia-de-la-natividad-becal-campeche.jpeg": 23232,
	"./descargas/iglesia-de-san-miguel-comala-colima.jpeg": 73120,
	"./descargas/iglesia-del-sagrado-corazon-de-jesus-sinaloa.jpeg": 3756,
	"./descargas/iglesia-hecelchakan-campeche.jpeg": 37740,
	"./descargas/iglesia-san-francisco-de-asis-hecelchakan-campeche-campeche.jpeg": 44380,
	"./descargas/iglesia-san-roman-santuario-del-santo-cristo-campeche-campeche.jpeg": 3084,
	"./descargas/iglesia-santa-rosa-de-viterbo-queretaro.jpeg": 48204,
	"./descargas/iglesia-y-convento-de-hopelchen-campeche.jpeg": 74212,
	"./descargas/interior-del-teatro-de-hidalgo-del-parral-chihuahua.jpeg": 70236,
	"./descargas/interior-hacienda-yaxcopoil-yucatan.jpeg": 48404,
	"./descargas/interior-parque-nacional-grutas-de-cacahuamilpa-guerrero.jpeg": 89748,
	"./descargas/isla-cerralvo-baja-california-sur.jpeg": 12720,
	"./descargas/isla-de-enmedio-veracruz.jpeg": 54456,
	"./descargas/isla-espiritu-santo-baja-california-sur.jpeg": 23708,
	"./descargas/islas-marietas-nayarit.jpeg": 30108,
	"./descargas/itacates-de-la-region-de-morelos.jpeg": 80528,
	"./descargas/iturbide-nuevo-leon.jpeg": 68443,
	"./descargas/jaguar-yumka-tabasco.jpeg": 91692,
	"./descargas/jardin-de-piedras-parque-natural-mexiquillo-durango.jpeg": 57420,
	"./descargas/jardin-escultorico-edward-james-xilitla-san-luis-potosi.jpeg": 29244,
	"./descargas/jardin-libertad-colima.jpeg": 29156,
	"./descargas/jardin-parroquia-san-jeronimo-aculco-estado-de-mexico.jpeg": 90800,
	"./descargas/jardin-surrealista-xilitla-san-luis-potosi.jpg": 83668,
	"./descargas/jardines-de-colima.jpeg": 65100,
	"./descargas/jardines-de-la-hacienda-de-san-antonio-colima.jpeg": 26316,
	"./descargas/jardines-de-mexico-en-xochitepec-morelos.jpeg": 54852,
	"./descargas/jilotepec-estado-de-mexico-pueblos-magicos.mp4": 21484,
	"./descargas/jilotepec-estado-de-mexico.jpeg": 91388,
	"./descargas/jimador-en-tequila-jalisco.jpeg": 25196,
	"./descargas/jiquilpan-de-juarez-michoacan.jpeg": 35608,
	"./descargas/juriquilla-queretaro.jpeg": 31440,
	"./descargas/kiosko-de-explanada-principal-de-xochitepec-morelos.jpeg": 53392,
	"./descargas/kiosko-del-parque-de-tepoztlan-morelos.jpeg": 41624,
	"./descargas/kiosko-del-parque-de-tlayacapan-morelos.jpeg": 73628,
	"./descargas/kiosko-en-el-centro-de-hidalgo-del-parral-chihuahua.jpeg": 29896,
	"./descargas/kiosko-en-jilotepec-estado-de-mexico.jpeg": 86840,
	"./descargas/kiosko-en-tlaxcala-tlaxcala.jpeg": 22011,
	"./descargas/kukulkan-campeche.jpeg": 38671,
	"./descargas/la-aduana-matamoros-tamaulipas-1.jpeg": 4536,
	"./descargas/la-aduana-matamoros-tamaulipas.jpeg": 36552,
	"./descargas/la-bocatoma-gomez-farias-tamaulipas.jpeg": 47040,
	"./descargas/la-bocatoma-tamaulipas.jpeg": 56700,
	"./descargas/la-casona-de-santa-lucia-nuevo-leon.jpeg": 92540,
	"./descargas/la-catedral-de-tepic-nayarit.jpeg": 15060,
	"./descargas/la-ferreria-durango.jpeg": 35376,
	"./descargas/la-hacienda-de-san-antonio-colima.jpeg": 75424,
	"./descargas/la-isla-tzibanza-cadereyta-de-montes-queretaro.jpeg": 2108,
	"./descargas/la-luna-y-el-sol-meztitlan-hidalgo.jpeg": 17056,
	"./descargas/la-parroquia-de-nuestra-senora-de-los-dolores-dolores-hidalgo-guanajuato.jpeg": 12328,
	"./descargas/la-paz-baja-california-sur-lugar-de-interes-en-mexico-aleman.mp4": 90388,
	"./descargas/la-paz-baja-california-sur-lugar-de-interes-en-mexico-chino.mp4": 24504,
	"./descargas/la-paz-baja-california-sur-lugar-de-interes-en-mexico-frances.mp4": 34740,
	"./descargas/la-paz-baja-california-sur-lugar-de-interes-en-mexico-japones.mp4": 96824,
	"./descargas/la-paz-baja-california-sur-lugar-de-interes-en-mexico-portugues.mp4": 99456,
	"./descargas/la-paz-baja-california-sur-lugar-de-interes-en-mexico.mp4": 78292,
	"./descargas/la-pila-chiapa-de-corzo-chiapas.jpeg": 49172,
	"./descargas/la-presa-de-la-soledad-queretaro.jpeg": 34392,
	"./descargas/la-reserva-de-la-biosfera-cuatro-cienegas-coahuila.jpeg": 84308,
	"./descargas/la-venta-tabasco.jpeg": 35316,
	"./descargas/la-villa-ciudad-de-mexico.jpeg": 69512,
	"./descargas/lago-de-san-miguel-regla-hidalgo.jpeg": 60196,
	"./descargas/lago-de-tequesquitengo-1.jpeg": 42764,
	"./descargas/laguna-bacalar-quintana-roo.jpeg": 27376,
	"./descargas/laguna-de-acuitlapilco-tlaxcala.jpeg": 60400,
	"./descargas/laguna-de-bacalar-quintana-roo.jpeg": 36884,
	"./descargas/laguna-de-las-ilusiones-villahermosa-tabasco.jpeg": 66104,
	"./descargas/laguna-de-miramar-chiapas.jpeg": 39928,
	"./descargas/laguna-de-yuriria-guanajuato.jpeg": 53376,
	"./descargas/laguna-la-maria-colima.jpeg": 15224,
	"./descargas/laguna-santiaguillo-durango.jpeg": 66812,
	"./descargas/las-islitas-nayarit.jpeg": 56992,
	"./descargas/loreto-baja-california-sur.jpeg": 83012,
	"./descargas/los-arcos-de-el-parian-nochistlan-de-mejia-zacatecas.jpeg": 6740,
	"./descargas/los-arcos-de-queretaro-queretaro.jpeg": 32932,
	"./descargas/los-barriles-baja-california-sur.jpeg": 90560,
	"./descargas/los-portales-tlaxcala.jpeg": 72588,
	"./descargas/los-troncones-ciudad-victoria-tamaulipas.jpeg": 41180,
	"./descargas/lugar-de-interes-mazatlan-aleman.mp4": 78400,
	"./descargas/lugar-de-interes-mazatlan-en-chino.mp4": 8232,
	"./descargas/lugar-de-interes-mazatlan-en-ingles.mp4": 97724,
	"./descargas/lugar-de-interes-mazatlan-frances.mp4": 20423,
	"./descargas/lugar-de-interes-mazatlan-italiano.mp4": 91268,
	"./descargas/lugar-de-interes-mazatlan-japones.mp4": 75140,
	"./descargas/lugar-de-interes-mazatlan-portugues.mp4": 50780,
	"./descargas/lugar-de-interes-mazatlan.mp4": 82384,
	"./descargas/lugar-de-interes-puerto-vallarta.mp4": 39064,
	"./descargas/lugar-de-interes-tequesquitengo.mp4": 21852,
	"./descargas/magdalena-de-kino-sonora.jpeg": 31588,
	"./descargas/mahahual-quintana-roo.jpeg": 54836,
	"./descargas/malecon-la-paz-baja-california.jpg": 90640,
	"./descargas/malecon-loreto-baja-california.jpg": 91068,
	"./descargas/manantiales-kinjua-meztitlan-hidalgo.jpeg": 39231,
	"./descargas/manglar-la-tovara-nayarit-1.jpeg": 28228,
	"./descargas/manglar-la-tovara-nayarit.jpeg": 17899,
	"./descargas/manglares-pantanos-de-centla-tabasco.jpeg": 97115,
	"./descargas/manglares-tuxpan-veracruz.jpeg": 39524,
	"./descargas/manos-de-artesanos-de-tlayacapan-morelos.jpeg": 69358,
	"./descargas/manos-de-cangrejo-gastronomia-de-campeche.jpeg": 13528,
	"./descargas/mantarrayas-en-baja-california-sur.jpeg": 17544,
	"./descargas/manzanillo-colima.jpeg": 72080,
	"./descargas/mariachis-en-colima.jpeg": 18688,
	"./descargas/marina-isla-navidad-colima.jpeg": 39740,
	"./descargas/mascota-jalisco.jpeg": 41484,
	"./descargas/matacanes-nuevo-leon.jpeg": 33728,
	"./descargas/mazamitla-jalisco.jpeg": 95456,
	"./descargas/mazunte-oaxaca.jpeg": 54252,
	"./descargas/meditacion-en-morelos.jpeg": 59728,
	"./descargas/mercado-barrio-antiguo-monterrey-nuevo-leon.jpeg": 41320,
	"./descargas/mercado-de-artesanias-el-parian-puebla.jpeg": 10560,
	"./descargas/mercado-organico-en-la-crucecita-oaxaca.jpeg": 70580,
	"./descargas/merida-yucatan-1.jpeg": 34208,
	"./descargas/merida-yucatan.jpeg": 14128,
	"./descargas/mina-el-eden-zacatecas-1.jpeg": 33143,
	"./descargas/mina-el-eden-zacatecas.jpeg": 1876,
	"./descargas/mina-santa-rosalia-baja-california.jpg": 6084,
	"./descargas/mineral-de-angangueo-michoacan.jpeg": 54367,
	"./descargas/mirador-cuatro-palos-sierra-gorda-queretaro.jpeg": 48812,
	"./descargas/mirador-de-barranca-del-cobre-chihuahua.jpeg": 70680,
	"./descargas/mirador-en-isla-navidad-colima.jpeg": 99356,
	"./descargas/mirador-la-nariz-surutato-sinaloa.jpeg": 44404,
	"./descargas/mirador-la-rumorosa-tecate-baja-california.jpg": 77111,
	"./descargas/mirador-los-laureles-durango.jpeg": 28004,
	"./descargas/mirador-meztitlan-hidalgo.jpeg": 18540,
	"./descargas/mirador-san-cristobal-de-las-casas-chiapas.jpeg": 98512,
	"./descargas/mision-de-san-bernardo-guerrero-coahuila.jpeg": 44340,
	"./descargas/mision-de-san-ignacio-de-kadda-kaaman-mulege-baja-california-sur.jpeg": 90636,
	"./descargas/mision-de-san-jose-de-comondu-baja-california-sur.jpeg": 1172,
	"./descargas/mision-de-san-miguel-conca-queretaro-1.jpeg": 20932,
	"./descargas/mision-de-san-miguel-conca-queretaro.jpeg": 83240,
	"./descargas/mision-nuestra-senora-de-loreto-concho-loreto-baja-california.jpg": 67012,
	"./descargas/mole-oaxaqueno.jpeg": 66880,
	"./descargas/monumento-a-la-patria-merida-yucatan.jpeg": 77484,
	"./descargas/monumento-paloma-de-la-paz-malecon-costero-coatzacoalcos-veracruz.jpeg": 36700,
	"./descargas/muelle-de-san-blas-nayarit.jpeg": 13024,
	"./descargas/muro-de-los-muertos-en-ajijic.jpeg": 26060,
	"./descargas/muro-fronterizo-tijuana-baja-california.jpg": 75008,
	"./descargas/museo-de-antropologia-ciudad-de-mexico.jpeg": 61324,
	"./descargas/museo-de-arte-de-tlaxcala-tlaxcala.jpeg": 41444,
	"./descargas/museo-de-arte-e-historia-en-leon-guanajuato.jpeg": 82788,
	"./descargas/museo-de-la-revolucion-de-torreon-coahuila.jpeg": 65952,
	"./descargas/museo-de-las-californias-tijuana-baja-california.JPG": 14056,
	"./descargas/museo-de-las-culturas-populares-e-indigenas-hermosillo-sonora.jpeg": 21440,
	"./descargas/museo-de-san-ildefonso-ciudad-de-mexico.jpeg": 87348,
	"./descargas/museo-de-sitio-mina-de-acosta-mineral-del-monte-hidalgo.jpeg": 32888,
	"./descargas/museo-del-desierto-arteaga-coahuila.jpeg": 59368,
	"./descargas/museo-del-desierto-saltillo-coahuila.jpeg": 4444,
	"./descargas/museo-del-futbol-salon-de-la-fama-pachuca-hidalgo.jpeg": 81856,
	"./descargas/museo-del-palacio-de-gobierno-nuevo-leon.jpeg": 57228,
	"./descargas/museo-del-taco-tijuana-baja-california.jpg": 43684,
	"./descargas/museo-emiliano-zapata-en-tlaltizapan-de-zapata-morelos.jpeg": 55192,
	"./descargas/museo-leonora-carrington-san-luis-potosi.jpeg": 20996,
	"./descargas/museo-mina-las-dos-estrellas-tlalpujahua-michoacan.jpeg": 33324,
	"./descargas/museo-nacional-del-virreinato-tepotzotlan-estado-de-mexico.jpeg": 18792,
	"./descargas/museo-regional-capital-durango.jpeg": 9076,
	"./descargas/museo-regional-de-antropologia-palacio-canton-merida-yucatan.jpeg": 53492,
	"./descargas/museo-regional-de-historia-ciudad-victoria-tamaulipas.jpeg": 82372,
	"./descargas/museo-regional-tlaxcala.jpeg": 47212,
	"./descargas/museo-soumaya-ciudad-de-mexico.jpeg": 68516,
	"./descargas/museo-universitario-dr-luis-mario-schneider-malinalco-estado-de-mexico.jpeg": 61136,
	"./descargas/naturaleza-reserva-de-la-biosfera-sierra-gorda-queretaro.jpeg": 96264,
	"./descargas/neblina-en-pinal-de-amoles-queretaro.jpeg": 45364,
	"./descargas/ninos-martires-catedral-de-nuestra-senora-de-la-asuncion-tlaxcala-tlaxcala.jpeg": 99704,
	"./descargas/nochistlan-de-mejia-zacatecas.jpeg": 79008,
	"./descargas/observatorio-astronomico-universitario-iturbide-nuevo-leon.jpeg": 39432,
	"./descargas/omitlan-de-juarez-hidalgo.jpeg": 13604,
	"./descargas/paisaje-agavero-tequila-jalisco.jpeg": 5528,
	"./descargas/palacio-alvarado-en-hidalgo-del-parral-chihuahua.jpeg": 58312,
	"./descargas/palacio-de-bellas-artes-vista-desde-la-av-juarez-ciudad-de-mexico.jpeg": 72439,
	"./descargas/palacio-de-gobierno-del-estado-de-tlaxcala-tlaxcala.jpeg": 42576,
	"./descargas/palacio-de-hierro-en-orizaba-veracruz.jpeg": 45243,
	"./descargas/palacio-municipal-de-hecelchakan-campeche.jpeg": 82580,
	"./descargas/palacio-municipal-de-tlayacapan-morelos.jpeg": 34088,
	"./descargas/panoramica-de-la-zona-hotelera-de-acapulco.jpg": 61807,
	"./descargas/pantanos-de-centla-tabasco.jpeg": 23048,
	"./descargas/paracho-de-verduzco-michoacan.jpeg": 27143,
	"./descargas/paraje-el-naranjo-san-luis-potosi.jpg": 91152,
	"./descargas/pareja-feliz-en-el-mirador-de-manzanillo-colima.jpeg": 10700,
	"./descargas/parque-david-ben-gurion-pachuca-hidalgo.jpeg": 42996,
	"./descargas/parque-del-profesor-tecate-baja-california.jpg": 73551,
	"./descargas/parque-fundidora-monterrey-nuevo-leon.jpeg": 58388,
	"./descargas/parque-fundidora-nuevo-leon-1.jpeg": 51524,
	"./descargas/parque-las-banderas-campeche-campeche.jpeg": 8536,
	"./descargas/parque-lineal-sendero-el-capitan-san-luis-potosi.jpeg": 8432,
	"./descargas/parque-museo-la-venta-tabasco.jpeg": 69816,
	"./descargas/parque-nacional-cascada-de-basaseachi-chihuahua.jpeg": 73352,
	"./descargas/parque-nacional-grutas-de-cacahuamilpa-guerrero.jpeg": 26516,
	"./descargas/parque-nacional-lagunas-de-zempoala-morelos-1.jpeg": 99868,
	"./descargas/parque-nacional-lagunas-de-zempoala-morelos.jpeg": 52572,
	"./descargas/parque-nacional-sierra-de-organos-zacatecas.jpeg": 4420,
	"./descargas/parque-natural-mexiquillo-durango.jpeg": 83868,
	"./descargas/parque-paseo-del-viejo-oeste-durango.jpeg": 11560,
	"./descargas/parque-recreativo-el-salto-zaragoza-nuevo-leon.jpeg": 8212,
	"./descargas/parroquia-de-san-jeronimo-aculco-estado-de-mexico.jpeg": 13584,
	"./descargas/parroquia-de-san-miguel-arcangel-san-miguel-de-allende-guanajuato-1.jpeg": 24532,
	"./descargas/parroquia-de-san-miguel-arcangel-san-miguel-de-allende-guanajuato.jpeg": 80036,
	"./descargas/parroquia-de-san-pedro-y-san-pablo-jilotepec-estado-de-mexico.jpeg": 94884,
	"./descargas/parroquia-de-santa-maria-amealco-queretaro.jpeg": 93312,
	"./descargas/parroquia-de-santa-prisca-guerrero.jpeg": 31528,
	"./descargas/parroquia-la-purisima-concepcion-alpuyeca-morelos.jpeg": 76164,
	"./descargas/parroquia-santiago-apostol-santiago-nuevo-leon.jpeg": 54748,
	"./descargas/parroquia-santiago-apostol-tapijulapa-tabasco.jpeg": 58208,
	"./descargas/parroquia-y-ex-convento-de-san-jeronimo-aculco-estado-de-mexico.jpeg": 6364,
	"./descargas/paseo-de-las-escolleras-coatzacoalcos-veracruz.jpeg": 74576,
	"./descargas/paseo-en-globo-sierra-de-gomas-nuevo-leon.jpeg": 77104,
	"./descargas/paseo-en-yate-en-el-lago-de-tequesquitengo.jpeg": 87828,
	"./descargas/paseo-por-el-lago-de-tequesquitengo.jpeg": 68636,
	"./descargas/paseo-santa-lucia-nuevo-leon.jpeg": 26000,
	"./descargas/pastes-platillo-tradicional-de-hidalgo.jpeg": 47192,
	"./descargas/pedro-escobedo-queretaro.jpeg": 73344,
	"./descargas/personaje-en-el-parque-del-viejo-oeste-durango.jpeg": 99496,
	"./descargas/pico-de-orizaba-veracruz.jpeg": 28323,
	"./descargas/piedra-volada-raramuri-chihuahua.jpeg": 92248,
	"./descargas/pinacate-crater-colorado-sonora.jpeg": 62236,
	"./descargas/pinacate-sonora.jpeg": 69964,
	"./descargas/pinal-de-amoles-queretaro.jpeg": 77908,
	"./descargas/pinos-danzantes-zacatecas.jpeg": 67743,
	"./descargas/pinos-zacatecas.jpeg": 45596,
	"./descargas/piramide-del-adivino-uxmal-yucatan-1.jpeg": 49464,
	"./descargas/piramide-del-adivino-uxmal-yucatan.jpeg": 44748,
	"./descargas/piramide-del-malecon-de-coatzacoalcos-veracruz.jpeg": 69396,
	"./descargas/playa-carrizalillo-oaxaca.jpeg": 81676,
	"./descargas/playa-condesa-en-acapulco.jpg": 89624,
	"./descargas/playa-el-palmar-ixtapa-zihuatanejo-guerrero.jpeg": 92976,
	"./descargas/playa-en-nayarit.jpeg": 56636,
	"./descargas/playa-la-paz-balandra-baja-california-sur.jpeg": 66528,
	"./descargas/playa-la-ropa-ixtapa-zihuatanejo-guerrero-1.jpeg": 4272,
	"./descargas/playa-la-ropa-ixtapa-zihuatanejo-guerrero.jpeg": 94632,
	"./descargas/playa-norte-isla-mujeres-quintana-roo.jpeg": 62276,
	"./descargas/playa-paraiso-del-pescador-rincon-de-guayabitos-nayarit.jpeg": 31964,
	"./descargas/playa-rincon-de-guayabitos-nayarit.jpeg": 61412,
	"./descargas/playa-san-carlos-sonora.jpeg": 14812,
	"./descargas/playa-todos-santos-la-paz-baja-california.jpg": 68416,
	"./descargas/playas-en-nayarit.jpeg": 14080,
	"./descargas/playas-san-blas-nayarit.jpeg": 6940,
	"./descargas/plaza-de-armas-queretaro-queretaro.jpeg": 98996,
	"./descargas/plaza-de-armas-tampico-tamaulipas.jpeg": 63452,
	"./descargas/plaza-de-la-concordia-cholula-puebla.jpeg": 54944,
	"./descargas/plaza-de-la-soledad-san-miguel-de-allende-guanajuato.jpeg": 81916,
	"./descargas/plaza-de-toros-tlaxcala-tlaxcala.jpeg": 89836,
	"./descargas/portales-trinidad-de-cervantes-teul-zacatecas.jpeg": 38228,
	"./descargas/porton-clasico-del-centro-del-pueblo-de-tlaltizapan-de-zapata-morelos.jpeg": 25428,
	"./descargas/poza-verde-cenotes-tamaulipas.jpeg": 54048,
	"./descargas/presa-huites-choix-sinaloa.jpeg": 68056,
	"./descargas/presa-taxhimay-villa-del-carbon-estado-de-mexico.jpeg": 13964,
	"./descargas/presa-valle-de-bravo-estado-de-mexico.jpeg": 17944,
	"./descargas/presa-vicente-guerrero-tamaulipas.jpeg": 61636,
	"./descargas/presidencia-municipal-de-linares-nuevo-leon.jpeg": 31800,
	"./descargas/presidencia-municipal-de-omitlan-de-juarez-hidalgo.jpeg": 732,
	"./descargas/presidencia-municipal-de-zempoala-hidalgo.jpeg": 85964,
	"./descargas/prismas-basalticos-de-santa-maria-regla-hidalgo.jpeg": 89248,
	"./descargas/pueblo-magico-ajijic.mp4": 40916,
	"./descargas/pueblo-magico-cocula.mp4": 18888,
	"./descargas/pueblo-magico-otumba-estado-de-mexico-en-ingles.mp4": 7892,
	"./descargas/pueblo-magico-san-ignacio-sinaloa-aleman.mp4": 34728,
	"./descargas/pueblo-magico-san-ignacio-sinaloa-en-chino.mp4": 33748,
	"./descargas/pueblo-magico-san-ignacio-sinaloa-en-ingles.mp4": 21756,
	"./descargas/pueblo-magico-san-ignacio-sinaloa-frances.mp4": 73872,
	"./descargas/pueblo-magico-san-ignacio-sinaloa-italiano.mp4": 78548,
	"./descargas/pueblo-magico-san-ignacio-sinaloa-japones.mp4": 35084,
	"./descargas/pueblo-magico-san-ignacio-sinaloa-portugues.mp4": 96788,
	"./descargas/pueblo-magico-san-ignacio-sinaloa.mp4": 98348,
	"./descargas/pueblo-magico-sayula.mp4": 68,
	"./descargas/pueblo-magico-temacapulin.mp4": 63232,
	"./descargas/pueblo-magico-tetela-de-ocampo-puebla-japones.mp4": 45540,
	"./descargas/pueblo-magico-teziutlan-puebla-frances.mp4": 10616,
	"./descargas/pueblo-magico-tlaltizapan.mp4": 20244,
	"./descargas/pueblo-magico-tonatico-estado-de-mexico-en-aleman.mp4": 86588,
	"./descargas/pueblo-magico-xochitepec.mp4": 44156,
	"./descargas/puente-colgante-en-parque-aventura-chihuahua.jpeg": 66320,
	"./descargas/puente-de-hojuela-mapimi-durango.jpeg": 61244,
	"./descargas/puerto-arista-chiapas.jpeg": 10388,
	"./descargas/puerto-penasco-sonora.jpeg": 39252,
	"./descargas/puerto-vallarta-jalisco-1.jpeg": 70940,
	"./descargas/puerto-vallarta-jalisco.jpeg": 88240,
	"./descargas/puesta-de-sol-en-playa-tesoro-la-paz-baja-california.jpg": 9796,
	"./descargas/pulpo-a-las-brasas-gastronomia-de-campeche.jpeg": 73064,
	"./descargas/punta-de-mita-islas-marietas-nayarit.jpeg": 68144,
	"./descargas/rappel-arco-del-tiempo-chiapas.jpeg": 34848,
	"./descargas/real-de-catorce-san-luis-potosi.jpeg": 2240,
	"./descargas/real-del-monte-hidalgo.jpeg": 49604,
	"./descargas/region-de-vinos-cava-freixenet-queretaro.jpeg": 35708,
	"./descargas/reserva-de-la-biosfera-sierra-gorda-queretaro.jpeg": 91504,
	"./descargas/reserva-ecologica-de-nanciyaga-veracruz.jpeg": 67416,
	"./descargas/reserva-ecologica-villa-luz-tabasco-1.jpeg": 248,
	"./descargas/reserva-ecologica-villa-luz-tabasco.jpeg": 13468,
	"./descargas/riachuelo-reserva-de-la-biosfera-sierra-gorda-queretaro.jpeg": 4324,
	"./descargas/ribera-de-chapala-jalisco.jpeg": 25568,
	"./descargas/rincon-colorado-general-zepeda-coahuila.jpeg": 73716,
	"./descargas/rio-lagartos-yucatan.jpeg": 79560,
	"./descargas/rioverde-la-gruta-de-la-catedral-san-luis-potosi.jpeg": 85440,
	"./descargas/riviera-maya-quintana-roo-1.jpeg": 33900,
	"./descargas/riviera-maya-quintana-roo.jpeg": 8160,
	"./descargas/riviera-nayarit-nayarit.jpeg": 10148,
	"./descargas/rotonda-de-los-jalisciences-ilustres.jpeg": 18128,
	"./descargas/salto-de-eyipantla-san-andres-tuxtla-veracruz.jpeg": 74388,
	"./descargas/san-blas-nayarit-1.jpeg": 17788,
	"./descargas/san-blas-nayarit.jpeg": 62304,
	"./descargas/san-carlos-sonora.jpeg": 53276,
	"./descargas/san-cristobal-de-las-casas-chiapas.jpeg": 51728,
	"./descargas/san-juan-de-ulua-veracruz.jpeg": 7128,
	"./descargas/san-miguel-de-allende-guanajuato.jpeg": 73920,
	"./descargas/san-pablo-villa-de-mitla-oaxaca.jpeg": 35856,
	"./descargas/santa-clara-del-cobre-michoacan-1.jpeg": 98804,
	"./descargas/santa-clara-del-cobre-michoacan.jpeg": 43636,
	"./descargas/santa-maria-de-magdalena-de-kino-sonora.jpeg": 76832,
	"./descargas/santa-rosalia-baja-california-sur-aleman.mp4": 24612,
	"./descargas/santa-rosalia-baja-california-sur-chino.mp4": 33660,
	"./descargas/santa-rosalia-baja-california-sur-espanol.mp4": 31296,
	"./descargas/santa-rosalia-baja-california-sur-frances.mp4": 80644,
	"./descargas/santa-rosalia-baja-california-sur-italiano.mp4": 60380,
	"./descargas/santa-rosalia-baja-california-sur-japones.mp4": 33048,
	"./descargas/santa-rosalia-baja-california-sur-portugues.mp4": 65732,
	"./descargas/santuario-de-la-virgen-de-los-remedios-cholula-puebla.jpeg": 83144,
	"./descargas/santuario-de-las-luciernagas-nanacamilpa-tlaxcala.jpeg": 97191,
	"./descargas/santuario-de-mariposas-monarcas-michoacan.jpeg": 39364,
	"./descargas/santuario-diocesano-de-nuestra-senora-de-guadalupe-zamora-de-hidalgo-michoacan.jpeg": 6720,
	"./descargas/sayil-zona-arqueologica-yucatan.jpeg": 93448,
	"./descargas/sayula-jalisco.jpeg": 6136,
	"./descargas/sendero-de-santa-barbara-puentecillas-durango.jpeg": 3880,
	"./descargas/sendero-del-capitan-san-luis-potosi.jpeg": 93732,
	"./descargas/siierra-madre-occidental-durango.jpeg": 16420,
	"./descargas/sotano-golondrinas-aquismon-san-luis-potosi.jpeg": 63100,
	"./descargas/tabacalera-en-veracruz.jpeg": 82672,
	"./descargas/tallado-en-madera-tlaxcala-tlaxcala.jpeg": 14296,
	"./descargas/tapalpa-jalisco.jpeg": 95208,
	"./descargas/tapijulapa-tabasco.jpeg": 31080,
	"./descargas/tarde-soleada-en-el-lago-de-tequesquitengo.jpeg": 52416,
	"./descargas/tardes-en-cuitzeo-michoacan.jpeg": 7280,
	"./descargas/taxco-guerrero-1.jpeg": 69928,
	"./descargas/taxco-guerrero.jpeg": 3456,
	"./descargas/teatro-degollado-en-guadalajara-jalisco.jpeg": 96132,
	"./descargas/teatro-hidalgo-del-parral-chihuahua.jpeg": 56600,
	"./descargas/teatro-juarez-guanajuato-guanajuato.jpeg": 79312,
	"./descargas/teatro-xicohtencatl-en-tlaxcala-tlaxcala.jpeg": 42384,
	"./descargas/tecate-magico-parque-del-profesor.jpg": 43440,
	"./descargas/tejados-villa-del-carbon-estado-de-mexico.jpeg": 88980,
	"./descargas/teleferico-barranca-del-cobre-chihuahua.jpeg": 63016,
	"./descargas/teleferico-durango-durango.jpeg": 98516,
	"./descargas/temacapulin-jalisco.jpeg": 57128,
	"./descargas/temazcal-en-xochitepec-morelos.jpeg": 35428,
	"./descargas/templo-de-san-juan-parangaricutiro-michoacan.jpeg": 684,
	"./descargas/templo-de-santa-rosa-de-viterbo-queretaro.jpeg": 3092,
	"./descargas/templo-de-santiago-apostol-nuevo-leon.jpeg": 33124,
	"./descargas/templo-del-sagrario-en-patzcuaro-michoacan.jpeg": 95040,
	"./descargas/templo-y-ex-convento-de-san-francisco-de-asis-en-la-ciudad-de-queretaro.jpeg": 45487,
	"./descargas/templo-y-exconvento-de-san-andres-apostol-epazoyucan-hidalgo.jpeg": 53320,
	"./descargas/templo-y-exconvento-de-santo-domingo-de-guzman-de-oxolotan-tabasco.jpeg": 40872,
	"./descargas/tepoztlan-morelos.jpeg": 22368,
	"./descargas/tequisquiapan-vinedo-queretaro.jpeg": 56128,
	"./descargas/tianguis-artesanal-tepoztlan-morelos.jpeg": 83356,
	"./descargas/tierra-blanca-guanajuato.jpeg": 35232,
	"./descargas/tirolesa-cascada-de-micos-san-luis-potosi.jpeg": 40636,
	"./descargas/tirolesa-en-bicicleta-cascada-de-micos.jpg": 32015,
	"./descargas/tirolesa-puente-de-hojuela-durango.jpeg": 65420,
	"./descargas/tlacotalpan-veracruz.jpeg": 32752,
	"./descargas/tlaxco-centro-tlaxcala.jpeg": 90512,
	"./descargas/todos-santos-baja-california-sur.jpeg": 63644,
	"./descargas/todos-santos-baja-california-sur.jpg.jpeg": 36748,
	"./descargas/torre-del-reloj-del-palacio-municipal-del-ayuntamiento-de-merida-yucatan.jpeg": 42912,
	"./descargas/torre-latinoamericana-ciudad-de-mexico.jpeg": 97236,
	"./descargas/torreon-coahuila.jpeg": 86844,
	"./descargas/torta-ahogada-de-jalisco.jpeg": 93292,
	"./descargas/trabajador-playa-santa-rosalia-baja-california.jpg": 49224,
	"./descargas/trajineras-de-xochimilco-ciudad-de-mexico.jpeg": 21280,
	"./descargas/tranvia-en-puerto-de-veracruz.jpeg": 50244,
	"./descargas/tranvia-en-san-miguel-de-allende-guanajuato.jpeg": 40936,
	"./descargas/tulum-quintana-roo-1.jpeg": 28144,
	"./descargas/tulum-quintana-roo-2.jpeg": 87976,
	"./descargas/tulum-quintana-roo.jpeg": 16616,
	"./descargas/turistas-en-el-canon-del-sumidero-chiapas.jpeg": 6456,
	"./descargas/vajillas-artesanales-en-michoacan.jpeg": 57432,
	"./descargas/valle-de-piedras-encimadas-zacatlan-de-las-manzanas-puebla.jpeg": 13764,
	"./descargas/valle-de-tlaxcala-tlaxcala.jpeg": 45120,
	"./descargas/valquirico-tlaxcala.jpeg": 93260,
	"./descargas/vida-nocturna-en-puerto-vallarta-jalisco.jpeg": 28688,
	"./descargas/vidrio-soplado-en-michoacan.jpeg": 3352,
	"./descargas/villa-del-carbon-estado-de-mexico-1.jpeg": 82200,
	"./descargas/villa-del-carbon-estado-de-mexico.jpeg": 24216,
	"./descargas/vinedo-cuna-de-tierra-guanajuato.jpeg": 96988,
	"./descargas/vinedo-en-guanajuato.jpeg": 21924,
	"./descargas/vinedos-casa-madero-parras-coahuila.jpeg": 40016,
	"./descargas/vinos-de-coahuila-coahuila.jpeg": 30652,
	"./descargas/vista-aerea-de-jardines-de-mexico-en-xochitepec-morelos.jpeg": 35416,
	"./descargas/vista-aerea-de-la-isla-navidad-en-colima.jpeg": 71792,
	"./descargas/vista-aerea-del-museo-historico-de-acapulco-fuerte-san-diego.jpg": 54416,
	"./descargas/vista-aerea-del-parque-de-tepoztlan-morelos.jpeg": 63768,
	"./descargas/vista-aerea-del-parque-nacional-cascada-de-basaseachi-chihuahua.jpeg": 92491,
	"./descargas/vista-de-guanajuato-guanajuato-desde-el-mirador.jpeg": 28132,
	"./descargas/vista-del-palacio-municipal-de-tlayacapan-morelos.jpeg": 79148,
	"./descargas/vista-panoramica-del-canon-del-sumidero-chiapas.jpeg": 6383,
	"./descargas/volador-de-papantla-veracruz.jpeg": 53268,
	"./descargas/voladores-de-papantla-en-veracruz.jpeg": 63152,
	"./descargas/voladores-de-tamaleton-san-luis-potosi.jpeg": 6688,
	"./descargas/volcan-chichonal-chiapas.jpeg": 24356,
	"./descargas/vuelta-en-las-dunas-de-samalayuca-chihuahua.jpeg": 47820,
	"./descargas/wtc-ciudad-de-mexico.jpeg": 18440,
	"./descargas/xochicalco-morelos.jpeg": 89404,
	"./descargas/zihuatanejo-guerrero.jpeg": 19832,
	"./descargas/zocalo-de-alvarado-veracruz.jpeg": 9628,
	"./descargas/zocalo-de-la-ciudad-de-mexico.jpeg": 77132,
	"./descargas/zona-arqueologica-cempoala-veracruz.jpeg": 36156,
	"./descargas/zona-arqueologica-chichen-itza-yucatan-1.jpeg": 16296,
	"./descargas/zona-arqueologica-chichen-itza-yucatan.jpeg": 32340,
	"./descargas/zona-arqueologica-comalcalco-tabasco.jpeg": 72580,
	"./descargas/zona-arqueologica-de-cantona-puebla.jpeg": 76604,
	"./descargas/zona-arqueologica-de-chalcatzingo-morelos.jpeg": 36684,
	"./descargas/zona-arqueologica-de-dzibilnocac-campeche.jpeg": 86864,
	"./descargas/zona-arqueologica-de-ek-balam-yucatan.jpeg": 19920,
	"./descargas/zona-arqueologica-de-hochob-campeche.jpeg": 30584,
	"./descargas/zona-arqueologica-de-huapalcalco-hidalgo.jpeg": 38928,
	"./descargas/zona-arqueologica-de-monte-alban-oaxaca-2.jpeg": 79972,
	"./descargas/zona-arqueologica-de-palenque-chiapas.jpeg": 74820,
	"./descargas/zona-arqueologica-de-paquime-chihuahua.jpeg": 83332,
	"./descargas/zona-arqueologica-de-tula-hidalgo.jpeg": 75628,
	"./descargas/zona-arqueologica-de-uxmal-yucatan.jpeg": 24508,
	"./descargas/zona-arqueologica-de-xochicalco-morelos.jpeg": 2908,
	"./descargas/zona-arqueologica-edzna-campeche.jpeg": 368,
	"./descargas/zona-arqueologica-el-cerrito-queretaro.jpeg": 2068,
	"./descargas/zona-arqueologica-ixtlan-del-rio-nayarit.jpeg": 75596,
	"./descargas/zona-arqueologica-moral-reforma-tabasco.jpeg": 76576,
	"./descargas/zona-arqueologica-teotihuacan-estado-de-mexico.jpeg": 40960,
	"./descargas/zona-arqueologica-tizatlan-tlaxcala-tlaxcala.jpeg": 28928,
	"./descargas/zona-arqueologica-xihuingo-hidalgo.jpeg": 84048,
	"./descargas/zona-arqueologica-xochicalco-y-museo-de-sitio-morelos.jpeg": 2231,
	"./descargas/zona-del-silencio-mapimi-durango.jpeg": 18492,
	"./destinations/02-Nuevo-Vallarta_11zon.jpg": 68540,
	"./destinations/03-Sayulita_11zon.jpg": 112,
	"./destinations/05-San-Pancho_11zon.jpg": 95540,
	"./destinations/100_8665.jpg": 94796,
	"./destinations/BCN_ensenada_135.jpg": 10668,
	"./destinations/BCN_ensenada_619.jpg": 36304,
	"./destinations/BCN_ensenada_733.jpg": 30832,
	"./destinations/BCN_puerto_nuevo_15.jpg": 36100,
	"./destinations/BCN_tecate_189.jpg": 37120,
	"./destinations/BCN_tijuana_1146.jpg": 13868,
	"./destinations/BCN_tijuana_259.jpg": 24272,
	"./destinations/BCS_Los_cabos_59.jpg": 66668,
	"./destinations/BCS_los_cabos_2_31.jpg": 38652,
	"./destinations/BCS_t_1220.jpg": 62820,
	"./destinations/BCS_t_2024.jpg": 84247,
	"./destinations/BCS_t_2956.jpg": 38152,
	"./destinations/BCS_t_96.jpg": 11936,
	"./destinations/BCS_tiburonballena.jpg": 42072,
	"./destinations/BCS_todos_santos_23.jpg": 99760,
	"./destinations/BajaCaliforniaSurLosCabos_11zon.webp": 84168,
	"./destinations/BajaCaliforniaValleGuadalupe_11zon.webp": 87920,
	"./destinations/BocadeTunelAguascalientes.jpg": 47856,
	"./destinations/BosquesDeMontesionDurango.webp": 96872,
	"./destinations/CAM_Dzibilnocac26.jpg": 47348,
	"./destinations/CAM_Edzna49.jpg": 16508,
	"./destinations/CAM_Edzna80.jpg": 72368,
	"./destinations/CAM_Hochob8.jpg": 34252,
	"./destinations/CAM_campeche115.jpg": 11164,
	"./destinations/CAM_campeche140.jpg": 61023,
	"./destinations/CAM_campeche256.jpg": 87280,
	"./destinations/CAM_champoton62.jpg": 2292,
	"./destinations/CHIH_casasgrandes_paquime_335.jpg": 71284,
	"./destinations/CHIH_casasgrandes_paquime_640.jpg": 65876,
	"./destinations/CHIH_casasgrandes_paquime_873.jpg": 32736,
	"./destinations/CHIH_cusarare241.jpg": 59196,
	"./destinations/CHIH_cusarare46.jpg": 53524,
	"./destinations/CHIH_parral_208.jpg": 90192,
	"./destinations/CHIH_sierra_158.jpg": 596,
	"./destinations/CHIS_agua_azul_46.jpg": 74188,
	"./destinations/CHIS_cannondelsumidero_32.jpg": 86104,
	"./destinations/CHIS_misol_ha_17.jpg": 24920,
	"./destinations/CHIS_palenque_18.jpg": 46744,
	"./destinations/CHIS_palenque_25.jpg": 5924,
	"./destinations/CHIS_palenque_32.jpg": 84628,
	"./destinations/CHIS_sancristobal_172.jpg": 35928,
	"./destinations/CHIS_sancristobal_43.jpg": 24980,
	"./destinations/COAH_2_saltillo_77.jpg": 53028,
	"./destinations/COAH_2_torreon_170.webp": 30408,
	"./destinations/COAH_2_torreon_51.jpg": 3016,
	"./destinations/COAH_Petroglifos126.jpg": 27245,
	"./destinations/COAH_Saltillo1204.webp": 25408,
	"./destinations/COAH_Saltillo1737.jpg": 99140,
	"./destinations/COAH_Saltillo2534.webp": 63536,
	"./destinations/COAH_Saltillo988.jpg": 92544,
	"./destinations/COL_colima_111.jpg": 17564,
	"./destinations/COL_colima_170.webp": 4352,
	"./destinations/COL_colima_321.jpg": 17996,
	"./destinations/COL_islanavidad_239.webp": 99176,
	"./destinations/COL_islanavidad_40.webp": 5870,
	"./destinations/COL_manzanillo_57.jpg": 56012,
	"./destinations/COL_tortugas_122.webp": 45472,
	"./destinations/CampecheCalakmul_11zon.webp": 12032,
	"./destinations/CatedralAguascalientes.webp": 33536,
	"./destinations/CentroCDMX.webp": 92472,
	"./destinations/CerroDelaCampanaHermosilloSonora.webp": 16444,
	"./destinations/ChetumalQuintanaRoo.webp": 67280,
	"./destinations/ChiapasPalenque.webp": 26070,
	"./destinations/CiudadDeMexicoBellasArtes_11zon.webp": 80232,
	"./destinations/CiudadDeOaxaca.webp": 56460,
	"./destinations/CoahuilaParras.webp": 78696,
	"./destinations/ColimaManzanillo_11zon.webp": 8580,
	"./destinations/ColimaPlaya2.webp": 23492,
	"./destinations/CostaOaxaca.webp": 56424,
	"./destinations/CristoRotoAguascalientes.webp": 86784,
	"./destinations/DAN_0084_11zon.webp": 28784,
	"./destinations/DAN_0938_11zon.webp": 26208,
	"./destinations/DAN_0942-_1__11zon.webp": 99832,
	"./destinations/DAN_7610_11zon.webp": 34504,
	"./destinations/DF_bellas_artes_t_2.jpg": 76900,
	"./destinations/DF_centro1_t_278.webp": 33216,
	"./destinations/DF_estadio_CU_48.webp": 72064,
	"./destinations/DF_unam_21.webp": 13280,
	"./destinations/DF_xochimilco_t_12.webp": 74840,
	"./destinations/DGO_Hda_la_joya_5.webp": 32384,
	"./destinations/DGO_trajes_tipicos_20.webp": 27952,
	"./destinations/DGO_trajes_tipicos_35.webp": 49384,
	"./destinations/Dgo_Ciudad_Durango223.webp": 42422,
	"./destinations/Dgo_Ciudad_Durango517.webp": 81968,
	"./destinations/Dgo_Puente_de_ojuela204.webp": 42546,
	"./destinations/DianaCazadoraCDMX.webp": 54162,
	"./destinations/DurangoPaisaje.webp": 91472,
	"./destinations/ElOroPalaciomunicipalEstadodeMexico.webp": 93560,
	"./destinations/EscalerasCaracolSanLuisPotosi.webp": 34360,
	"./destinations/EscolleraPlayaMiramarCiudadMaderoTamaulipas.webp": 5552,
	"./destinations/EstadoDeMexicoTeotihuacan_11zon.webp": 10968,
	"./destinations/FeriadeSanMarcosAguascalientes.webp": 26296,
	"./destinations/GRO_Ixtapa_189.webp": 75756,
	"./destinations/GRO_acapulco_1926.webp": 88888,
	"./destinations/GRO_acapulco_407.webp": 61440,
	"./destinations/GRO_acapulco_665-Edit.webp": 6696,
	"./destinations/GRO_barravieja_232.webp": 71692,
	"./destinations/GRO_cacahuamilpa_73.webp": 72488,
	"./destinations/GTO_SMallende_213.webp": 30152,
	"./destinations/GTO_aereas_77.webp": 59928,
	"./destinations/GTO_artesanos_gto_1.webp": 28192,
	"./destinations/GTO_charreria_73.webp": 87168,
	"./destinations/GTO_dolores_311.webp": 11076,
	"./destinations/GTO_guanajuato_753.webp": 93456,
	"./destinations/GTO_guanajuato_845.webp": 74804,
	"./destinations/GTO_leon_t_75.webp": 65736,
	"./destinations/GomezFariasElCieloTamaulipas.webp": 63556,
	"./destinations/GranjaDePerlasMardeCortezSonora.webp": 56240,
	"./destinations/GrupodeDanzaenBahiaSantaCruzOaxaca.webp": 91380,
	"./destinations/GuanajuatoSanMigueldeAllende_11zon.webp": 27488,
	"./destinations/GuerreroAcapulco_11zon.webp": 24896,
	"./destinations/HGO_bailable_115.webp": 17558,
	"./destinations/HGO_epazoyucan_10.webp": 93768,
	"./destinations/HGO_hda_sandiego_tlayayote_26.webp": 9064,
	"./destinations/HGO_hda_stamaria_regla_5.webp": 51170,
	"./destinations/HGO_metepec_56.webp": 55320,
	"./destinations/HGO_prismas_basalticos_10.webp": 99512,
	"./destinations/HGO_t2_acaxochitlan_16.webp": 63784,
	"./destinations/HamacasGuerrero.webp": 50928,
	"./destinations/Hgo_tula_003.jpg": 78676,
	"./destinations/HidalgoPrismasBasalticosBHuasca.webp": 83236,
	"./destinations/HolboxQuintanaRoo.webp": 44760,
	"./destinations/HuastecaAquismonPuebloMagicoCascadadeTamulSLP-1.webp": 86684,
	"./destinations/HuastecaAquismonPuebloMagicoCascadadeTamulSLP.webp": 61976,
	"./destinations/HuastecaAxtladeTerrazasCastillodelaSaludSLP.webp": 64188,
	"./destinations/HuastecaTamasopoCascadasdeTamasopoSLP.webp": 41504,
	"./destinations/IglesiaSanLuisPotosi.webp": 74522,
	"./destinations/Isla-Coral-2_11zon.webp": 34376,
	"./destinations/JAL_Hospicio_Cabanas_02.webp": 36128,
	"./destinations/JAL_Tortugas_51.webp": 89166,
	"./destinations/JAL_agaves_884.webp": 35784,
	"./destinations/JAL_barra_navidad_62.webp": 49992,
	"./destinations/JAL_general_10196.webp": 72600,
	"./destinations/JAL_general_9943.webp": 54656,
	"./destinations/JAL_tamarindo_501.webp": 76908,
	"./destinations/JAL_tequila_express_257o.webp": 15304,
	"./destinations/JaliscoGuadalajara_11zon.webp": 35042,
	"./destinations/LagunadeManialtepecOaxaca.webp": 15352,
	"./destinations/LasHadasColima.webp": 40988,
	"./destinations/LiberaciondeTortugasPlayaBacochoOaxaca.webp": 37904,
	"./destinations/MEX_acolman_92.webp": 41808,
	"./destinations/MEX_huexotla_t_10.webp": 85400,
	"./destinations/MEX_parapente_2_149.webp": 2768,
	"./destinations/MEX_t2_santarosadelima_4.webp": 7496,
	"./destinations/MEX_tepotzotlan_t_29.webp": 28208,
	"./destinations/MEX_texcutzingo_t_87.webp": 8904,
	"./destinations/MEX_toluca_t_6.webp": 39120,
	"./destinations/MICH_cuitzeo_98.webp": 3748,
	"./destinations/MICH_janitzio_38.webp": 38052,
	"./destinations/MICH_nurio_57.webp": 56392,
	"./destinations/MICH_patzcuaro_320.webp": 24928,
	"./destinations/MICH_patzcuaro_4.webp": 40256,
	"./destinations/MICH_staclara_97.webp": 67812,
	"./destinations/MICH_tzintzuntzan_94.webp": 98496,
	"./destinations/MOR_Hda_temixco_t_102.webp": 52608,
	"./destinations/MOR_atlatlaucan_t_4.webp": 89432,
	"./destinations/MOR_axochiapan_t_329.webp": 66928,
	"./destinations/MOR_chalcatzingo_t_49.webp": 16090,
	"./destinations/MOR_cocoyoc_133.webp": 83992,
	"./destinations/MOR_las_estacas_t_29.webp": 5160,
	"./destinations/MOR_tequesquitengo_t_24.webp": 65232,
	"./destinations/MOR_totolapan_t_25.webp": 85424,
	"./destinations/MacroPlazaMonterreyNuevoLeon.webp": 64584,
	"./destinations/ManzanilloColima.webp": 79696,
	"./destinations/MariposaMonarcaMichoacan.webp": 41568,
	"./destinations/MichoacanIglesia.webp": 15824,
	"./destinations/MitlaOaxaca.webp": 31742,
	"./destinations/MontealbanOaxaca.webp": 6232,
	"./destinations/Moreloscolor.jpg": 21572,
	"./destinations/MuseoAntropologiaCDMX.webp": 85476,
	"./destinations/NAY_RinconDeGuayabitos_Playas_05292.webp": 2524,
	"./destinations/NL_Monty_Fundidora33.webp": 30012,
	"./destinations/NL_Monty_Obispado25.webp": 53528,
	"./destinations/NL_Villa_Santiago59.webp": 37112,
	"./destinations/NL_cercado_cola_de_caballo9.webp": 36080,
	"./destinations/NL_monterrey_2_103.webp": 16552,
	"./destinations/NL_monterrey_2_159.webp": 80712,
	"./destinations/NayaritMarietas_11zon.webp": 95848,
	"./destinations/NuevoLeonMonterreyParqueFundidora_11zon.webp": 89192,
	"./destinations/OAX_arrazolalebrijes_32.webp": 14024,
	"./destinations/OAX_bartolocoyotepec_25.webp": 5202,
	"./destinations/OAX_ciudad_219.webp": 42540,
	"./destinations/OAX_ciudad_328.webp": 65242,
	"./destinations/OAX_ciudad_662.webp": 40536,
	"./destinations/OAX_costa_25.webp": 11432,
	"./destinations/OAX_mitla_50.webp": 10760,
	"./destinations/OAX_montealban_12.webp": 30656,
	"./destinations/OaxacaOaxaca.webp": 63478,
	"./destinations/ObispadoMonterreyNuevoLeon.webp": 9680,
	"./destinations/PMReal-de-CatorceSLP.webp": 41824,
	"./destinations/PMRealdeCatorce2.webp": 48452,
	"./destinations/PUE_alfenique_76.webp": 61728,
	"./destinations/PUE_catedral_17.webp": 58872,
	"./destinations/PUE_cholula_39.webp": 80162,
	"./destinations/PUE_cholula_9.webp": 13968,
	"./destinations/PUE_cuetzalan_145.webp": 97072,
	"./destinations/PUE_cuetzalan_163.webp": 69992,
	"./destinations/PUE_cuetzalan_843.webp": 79812,
	"./destinations/PUE_yohualichan_2.webp": 26016,
	"./destinations/PalacioDeGobiernoChihuahua.webp": 85760,
	"./destinations/ParroquiaJesusNazarenoAguascalientes.webp": 23976,
	"./destinations/PlayaCarrizalilloOaxaca.webp": 48256,
	"./destinations/PlayaPrincipalOaxaca.webp": 8292,
	"./destinations/PueblaChignahuapanFestivaldeLaVidaylaLuz.jpg": 73764,
	"./destinations/Pueblos-Magicos.webp": 84340,
	"./destinations/QRO_acueducto_49.webp": 17080,
	"./destinations/QRO_bernal_34.webp": 68096,
	"./destinations/QRO_galindo_194.webp": 70410,
	"./destinations/QRO_queretaro_1404.webp": 72248,
	"./destinations/QRO_queretaro_345.webp": 15624,
	"./destinations/QRO_queretaro_445.webp": 58264,
	"./destinations/QRO_sierra_gorda_23.webp": 66642,
	"./destinations/Qroo_Hotel_catalonia54-2.webp": 19320,
	"./destinations/Qroo_Isla_mujeres134-2.webp": 69148,
	"./destinations/Qroo_Isla_mujeres320_2.webp": 23096,
	"./destinations/Qroo_Isla_mujeres44_2.webp": 2104,
	"./destinations/Qroo_Xcaret22_2.webp": 31752,
	"./destinations/Qroo_ceiba_del_mar84.webp": 55976,
	"./destinations/QueratroVinosCavaFreixenet.jpg": 86235,
	"./destinations/QuintanaRooTulum_11zon_(1).webp": 76120,
	"./destinations/RealDeCatorceSanLuisPotosi.webp": 8264,
	"./destinations/RioGuayalejoJaumaveTamaulipas.webp": 27644,
	"./destinations/RutaMezcalCampanillaSLP.webp": 85112,
	"./destinations/SIN_El_fuerte_087.webp": 18100,
	"./destinations/SIN_escuinapa_3.webp": 26400,
	"./destinations/SIN_ferri_03.webp": 18396,
	"./destinations/SIN_fuerte_chepe_9.webp": 93472,
	"./destinations/SIN_fuerte_hotel_1.webp": 96608,
	"./destinations/SIN_guasave_1.webp": 64128,
	"./destinations/SIN_mazatlan_44.webp": 88176,
	"./destinations/SIN_quelite_249.webp": 39278,
	"./destinations/SLP-Xitla.webp": 89896,
	"./destinations/SLP_Tamtok_2724.webp": 16448,
	"./destinations/SLP_huasteca_0448.webp": 21416,
	"./destinations/SLP_huasteca_0812.webp": 26968,
	"./destinations/SLP_matehuala_47.webp": 49310,
	"./destinations/SLP_realdecatorce_1.webp": 77216,
	"./destinations/SLP_sanluispotosi_119.webp": 6192,
	"./destinations/SLP_sanluispotosi_63.webp": 20848,
	"./destinations/SLP_xilitla_4.webp": 23124,
	"./destinations/SON_alamos_635.webp": 52080,
	"./destinations/SON_caborca_10.jpg": 75716,
	"./destinations/SON_san_carlos_1037.webp": 19156,
	"./destinations/SON_san_carlos_483.webp": 98192,
	"./destinations/SON_san_carlos_489.webp": 45488,
	"./destinations/SanCarlosSonora.webp": 75304,
	"./destinations/SanLuisPotosiXilitlaJardinEscultoricodeEdwardJamesSLP.jpg": 19660,
	"./destinations/SinaloaMazatlan_11zon.webp": 55960,
	"./destinations/SonoraHermosillo_11zon.webp": 5668,
	"./destinations/StaCatarinaHuastecaNuevoLeon.webp": 93096,
	"./destinations/SurfZicatelaOaxaca.webp": 15896,
	"./destinations/TAB_Artesanos1.webp": 40200,
	"./destinations/TAB_Parque_la_venta115.webp": 9192,
	"./destinations/TAB_Parque_la_venta42.webp": 36648,
	"./destinations/TAB_Parque_la_venta47.webp": 56028,
	"./destinations/TAB_Parque_la_venta64.webp": 67680,
	"./destinations/TAB_Pomona22.webp": 18224,
	"./destinations/TAB_comalcalco45.webp": 70328,
	"./destinations/TAB_cupilco7.webp": 7248,
	"./destinations/TLX_Hda_soltepec_441.webp": 82528,
	"./destinations/TLX_Hda_soltepec_6.webp": 57616,
	"./destinations/TLX_cacaxtla_7.webp": 68328,
	"./destinations/TLX_cacaxtla_75.webp": 98944,
	"./destinations/TLX_ciudada_tlaxcala_09.webp": 47112,
	"./destinations/TLX_mascaras_7.webp": 55948,
	"./destinations/TLX_mural_22.webp": 93840,
	"./destinations/TLX_xochitecatl_35.webp": 31496,
	"./destinations/TMPS_ciudad_victoria_013.webp": 44168,
	"./destinations/TMPS_el_cielo_2_301.webp": 616,
	"./destinations/TMPS_tampico_2_62.webp": 76208,
	"./destinations/TMPS_tampico_2_874.webp": 71296,
	"./destinations/TabascoLaVenta_11zon.webp": 46920,
	"./destinations/TamaulipasTampico_11zon.webp": 4008,
	"./destinations/TamtokSanLuisPotosi.webp": 2058,
	"./destinations/TarahumaraChihuahua.webp": 80268,
	"./destinations/TaxcoGuerrero.webp": 65704,
	"./destinations/TemplodelSagradoCorazonenDurango.webp": 31840,
	"./destinations/TlaxcalaDanzantesCarnavalCatrines.jpg": 96160,
	"./destinations/TradicionHidrocalidaAguascalientes.webp": 29738,
	"./destinations/TradicionHidrocalidaAguascalientes2.webp": 86756,
	"./destinations/Tulum.webp": 7600,
	"./destinations/VER_San_juan_de_ulua144.webp": 52920,
	"./destinations/VER_antigua1.webp": 39896,
	"./destinations/VER_antigua21.webp": 1176,
	"./destinations/VER_catemaco508.webp": 72390,
	"./destinations/VER_coatepec10.webp": 53980,
	"./destinations/VER_costa_esmeralda342.webp": 24248,
	"./destinations/VER_eyipantla7.webp": 22408,
	"./destinations/VER_veracruz305.webp": 31944,
	"./destinations/VentanillaPlayaOaxaca.webp": 56446,
	"./destinations/VeracruzTajin.jpg": 4015,
	"./destinations/VillaSantiagoNuevoLeon.webp": 75019,
	"./destinations/YUC_Chichen_Itza33.webp": 83200,
	"./destinations/YUC_Chichen_Itza62.webp": 53298,
	"./destinations/YUC_Cusaman_Cenotes45.webp": 75896,
	"./destinations/YUC_Ek_balam60.webp": 40088,
	"./destinations/YUC_Hacienda_Ochil139.webp": 46192,
	"./destinations/YUC_Merida_132.webp": 40528,
	"./destinations/YUC_Uxmal59.webp": 13072,
	"./destinations/YUC_kabah_34.webp": 29892,
	"./destinations/YucatanCenoteMaya.jpg": 26956,
	"./destinations/ZAC_Fresnillo_1144.webp": 80387,
	"./destinations/ZAC_ciudad_de_Zacatecas_2098.webp": 57166,
	"./destinations/ZAC_gral_1733.webp": 224,
	"./destinations/ZAC_gral_1871.webp": 47386,
	"./destinations/ZAC_gral_3324.webp": 69360,
	"./destinations/ZAC_gral_3667.webp": 54192,
	"./destinations/ZAC_gral_432.webp": 99336,
	"./destinations/ZAC_zacatecas_museo_mina_1705.webp": 54960,
	"./destinations/Zacatecas_11zon.webp": 27262,
	"./destinations/_3SUQF~F.webp": 20120,
	"./destinations/_BCN_valle_guadalupe_22.webp": 95584,
	"./destinations/baileregionalAguascalientes.webp": 10448,
	"./destinations/boca-de-tunel.jpg": 79416,
	"./destinations/cascada.webp": 7188,
	"./destinations/colima_comala.webp": 53456,
	"./destinations/teatrodegollado.webp": 54972,
	"./destinations/teatromorelosAguascalientes.webp": 71800,
	"./diaMuertos/1.webp": 77844,
	"./diaMuertos/12.webp": 28088,
	"./diaMuertos/2.webp": 2480,
	"./diaMuertos/3.webp": 50376,
	"./diaMuertos/4.webp": 27264,
	"./diaMuertos/5.webp": 33384,
	"./diaMuertos/6.webp": 43004,
	"./diaMuertos/6old.webp": 68434,
	"./diaMuertos/7.webp": 23390,
	"./diaMuertos/Diademuertosbanner.webp": 30744,
	"./diaMuertos/Flyer_Dia_de_Muertos.gif": 63020,
	"./diaMuertos/Fondo amarillo 5.png": 42780,
	"./diaMuertos/MosaicoGrande.png": 79020,
	"./diaMuertos/calavera1.png": 2132,
	"./diaMuertos/calavera2.png": 93576,
	"./diaMuertos/calavera3.png": 76800,
	"./diaMuertos/calavera4.png": 16684,
	"./diaMuertos/calavera5.png": 66940,
	"./diaMuertos/calavera6.png": 84968,
	"./diaMuertos/calavera7.png": 37584,
	"./diaMuertos/diaMuertosBanner.png": 3452,
	"./diaMuertos/image86.png": 88239,
	"./diaMuertos/image87.png": 53424,
	"./diaMuertos/image88.png": 56192,
	"./enologia/Fondorosa.webp": 35546,
	"./enologia/banner_enologia.png": 8624,
	"./enologia/barril.svg": 76888,
	"./enologia/botellas.svg": 97844,
	"./enologia/cinta_roja.png": 57900,
	"./enologia/eno/enologia5.jpg": 21628,
	"./enologia/eno/enoturismo1.jpg": 78852,
	"./enologia/eno/enoturismo2.jpg": 22615,
	"./enologia/eno/enoturismo3.jpg": 11836,
	"./enologia/eno/enoturismo4.jpg": 6788,
	"./enologia/eno/enoturismo6.jpg": 51372,
	"./enologia/eno/enoturismo7.jpg": 7604,
	"./enologia/eno/enoturismo8.jpg": 66624,
	"./enologia/eno/enoturismo9.jpg": 87400,
	"./enologia/enologia-turismo.png": 24796,
	"./enologia/enologia1.png": 77436,
	"./enologia/enologia2.png": 79632,
	"./enologia/enologia3.png": 3360,
	"./enologia/enologia4.png": 77732,
	"./enologia/enologia5.jpg": 57916,
	"./enologia/enologia5_.jpg": 10965,
	"./enologia/img-descarga.png": 85544,
	"./enologia/mapa.svg": 91148,
	"./enologia/marcas.png": 69919,
	"./enologia/regiones.png": 57539,
	"./enologia/sacacorcho.svg": 79612,
	"./enologia/uvas.svg": 74452,
	"./experiences/aventuraGallery/7.jpg": 23215,
	"./experiences/aventuraGallery/7.webp": 26158,
	"./experiences/aventuraGallery/CHIS_agua_azul_46.jpg": 96096,
	"./experiences/aventuraGallery/CuatroCienagasCoahuila.jpg": 51716,
	"./experiences/aventuraGallery/GlobosLeonGuanajuato.jpg": 78820,
	"./experiences/aventuraGallery/GolfBCS.jpg": 56204,
	"./experiences/aventuraGallery/GolfBCS.webp": 1180,
	"./experiences/aventuraGallery/Grutas_Tolantongo_B_2C_Cardonal.jpg": 94416,
	"./experiences/aventuraGallery/LABUFADORAENSENADABC.jpg": 93500,
	"./experiences/aventuraGallery/LABUFADORAENSENADABC.webp": 24168,
	"./experiences/aventuraGallery/MazatlanSinaloa.webp": 48224,
	"./experiences/aventuraGallery/ROO_PlayaDelCarmen_Kayak-1137.jpg": 24836,
	"./experiences/aventuraGallery/SIN_guanacoa_257.webp": 54520,
	"./experiences/aventuraGallery/TRAVESIA-3(1).webp": 66592,
	"./experiences/aventuraGallery/loreto.jpg": 79296,
	"./experiences/aventuraGallery/sinaloa.jpg": 72428,
	"./experiences/bg.webp": 1880,
	"./experiences/bienestarGallery/BCS1.webp": 68412,
	"./experiences/bienestarGallery/MOR_Tepoztlan_HotelDosPiedras_LGBT-33.webp": 59320,
	"./experiences/bienestarGallery/bacalar.webp": 15408,
	"./experiences/bienestarGallery/bienestargto.webp": 95648,
	"./experiences/bienestarGallery/cenoteyucatan.webp": 38984,
	"./experiences/bienestarGallery/tabasco.webp": 13248,
	"./experiences/bienestarGallery/tecate.webp": 76376,
	"./experiences/open.svg": 53056,
	"./experiences/routesGastronomicGallery/AGREGAR-Tabasco_-del-cacaco-al-chocolate.webp": 84416,
	"./experiences/routesGastronomicGallery/Cajeta.webp": 72640,
	"./experiences/routesGastronomicGallery/ChileNogada.webp": 24688,
	"./experiences/routesGastronomicGallery/Gastronomia-CochinitaPibil-HaciendaOchil150.webp": 87864,
	"./experiences/routesGastronomicGallery/Gastronomia-Vaporcitos-HaciendaOchil51.webp": 66756,
	"./experiences/routesGastronomicGallery/HGO_acatlan_4_11zon.webp": 24336,
	"./experiences/routesGastronomicGallery/HGO_t2_actopan_356-_1__11zon.webp": 93608,
	"./experiences/routesGastronomicGallery/MEX_avandaro_t__147_11zon.webp": 49984,
	"./experiences/routesGastronomicGallery/Mariscos.webp": 54176,
	"./experiences/routesGastronomicGallery/PUE-Puebla-Gastronomia-JoyasColoniales-FabianGarcilita-BC3_3712_11zon.webp": 8584,
	"./experiences/routesGastronomicGallery/Papadzules5_11zon.webp": 66436,
	"./experiences/routesGastronomicGallery/Papadzules_11zon.webp": 71990,
	"./experiences/routesGastronomicGallery/Qroo_Lorenzillos_girls63-2_11zon.webp": 76956,
	"./experiences/routesGastronomicGallery/TMPS_tampico_2_131_11zon.webp": 3296,
	"./experiences/routesGastronomicGallery/Yucatan_Foto_13.webp": 98976,
	"./experiences/routesGastronomicGallery/cajeta.jpg": 11916,
	"./experiences/routesGastronomicGallery/deliciascaribe.webp": 17052,
	"./experiences/routesGastronomicGallery/guanajuatogastronomia.webp": 94816,
	"./experiences/routesGastronomicGallery/langostas.webp": 91620,
	"./experiences/routesGastronomicGallery/playadelcarmengastronomia.webp": 83842,
	"./experiences/routesGastronomicGallery/torremariscossinaloa.webp": 29016,
	"./experiences/routesGastronomicGallery/vendimiascoahuila.webp": 30304,
	"./experiences/solPlayaGallery/BCN_ensenada_7_11zon.webp": 13032,
	"./experiences/solPlayaGallery/BCS_cabo_pulmo_26_11zon.webp": 82812,
	"./experiences/solPlayaGallery/CancunQintanaRoo.webp": 66936,
	"./experiences/solPlayaGallery/ChamborTabasco.webp": 42624,
	"./experiences/solPlayaGallery/Cozumel.webp": 81976,
	"./experiences/solPlayaGallery/GRO_acapulco_1317_11zon.webp": 2586,
	"./experiences/solPlayaGallery/JAL_careyes_11_11zon.webp": 89840,
	"./experiences/solPlayaGallery/OAX_costa_25_11zon.webp": 37920,
	"./experiences/solPlayaGallery/Qroo_Hotel_catalonia63_2_11zon.webp": 5600,
	"./experiences/solPlayaGallery/Qroo_cancun_playa108.webp": 7795,
	"./experiences/solPlayaGallery/SIN_las_glorias_25_11zon.webp": 98424,
	"./experiences/solPlayaGallery/SON_SanCarlos_Mirador-138_11zon.webp": 46632,
	"./experiences/solPlayaGallery/TMPS_miramar_2_236_11zon.webp": 21464,
	"./experiences/solPlayaGallery/VER_catemaco104_11zon.webp": 27956,
	"./experiences/solPlayaGallery/bajacaliforniasur.webp": 63744,
	"./experiences/solPlayaGallery/coloradasyucatan.webp": 41244,
	"./experiences/solPlayaGallery/ferrisinaloa.webp": 72024,
	"./experiences/solPlayaGallery/fuertecampeche.webp": 38220,
	"./experiences/solPlayaGallery/islamujeres.webp": 29492,
	"./experiences/solPlayaGallery/rosarito.webp": 30064,
	"./experiences/solPlayaGallery/soconuscochiapas.webp": 63480,
	"./experiences/sostenibleGallery/BCS_tiburonballena.webp": 73776,
	"./experiences/sostenibleGallery/CHIH_creel47-_1__11zon.webp": 51584,
	"./experiences/sostenibleGallery/artesaniastabasco.webp": 83672,
	"./experiences/sostenibleGallery/fresas.webp": 18478,
	"./experiences/sostenibleGallery/sostenible_buzo.jpg": 34492,
	"./experiences/sostenibleGallery/telar.webp": 80780,
	"./experiences/sostenibleGallery/tortugatulum.webp": 79680,
	"./experiences/wedding/BAcapulco.webp": 2440,
	"./experiences/wedding/BLapaz.webp": 53696,
	"./experiences/wedding/BODAMAYA.webp": 90676,
	"./experiences/wedding/Boda BC.webp": 58212,
	"./experiences/wedding/Boda Beso.webp": 43140,
	"./experiences/wedding/Boda caribe.webp": 60264,
	"./experiences/wedding/BodaPueblosQueretaro.webp": 26546,
	"./experiences/wedding/BodaTradicionalChichimeca.webp": 72176,
	"./experiences/wedding/BodaTradicionalNahua.webp": 91456,
	"./experiences/wedding/BodaTradicionalVeracruz.webp": 55100,
	"./experiences/wedding/Bodas Cabos.webp": 86448,
	"./experiences/wedding/Bodas Huatulco.webp": 24432,
	"./experiences/wedding/Ceremonia-Wixarika-Nayarit.webp": 56656,
	"./experiences/wedding/Ceremonia_Wixarika_Zacatecas.webp": 40524,
	"./experiences/wedding/Despedida_Puerto_Vallarta.webp": 31816,
	"./experiences/wedding/Entrega_de_anillo_Queretaro.webp": 2266,
	"./experiences/wedding/Entregadeanilloqueretaro.webp": 50168,
	"./experiences/wedding/Familia.webp": 97230,
	"./experiences/wedding/Novios-Puerto-Vallarta.webp": 65936,
	"./experiences/wedding/NoviosQueretaro.webp": 56836,
	"./experiences/wedding/Novios_Queretaro.webp": 20248,
	"./experiences/wedding/Novios_vestidos_trad._guerrero.webp": 56804,
	"./experiences/wedding/Pareja.webp": 82992,
	"./experiences/wedding/ParejaLGBT-PuertoVallartaaniversario.webp": 2410,
	"./experiences/wedding/ParejaQueretaro.webp": 14340,
	"./experiences/wedding/SanCristobaldelascasasBoda.jpg": 91432,
	"./experiences/wedding/SanCristobaldelascasasBoda.webp": 99096,
	"./experiences/wedding/San_Gabriel_Gto.webp": 74024,
	"./experiences/wedding/TapachulaChiapas.jpg": 20832,
	"./experiences/wedding/TapachulaChiapas.webp": 74160,
	"./experiences/wedding/Tlaquepaque-lgbt.jpg": 75700,
	"./experiences/wedding/TuxtlaGutierrezChiapas.jpg": 17092,
	"./experiences/wedding/TuxtlaGutierrezChiapas.webp": 95728,
	"./experiences/wedding/ZAC_zacatecasmina.webp": 60626,
	"./experiences/wedding/boda_tradicional_Nahua_Veracruz.webp": 56112,
	"./experiences/wedding/bodaplaya.webp": 6064,
	"./experiences/wedding/bodatradicionalhidalgo.webp": 7488,
	"./experiences/wedding/cinta_morada.jpg": 99204,
	"./experiences/wedding/huatulco.webp": 26232,
	"./experiences/wedding/lgbt-clavijero.jpg": 28760,
	"./experiences/wedding/lgbt-inclusivo.jpg": 20372,
	"./experiences/wedding/morelia-lgbt.jpg": 56472,
	"./experiences/wedding/pride-lgbt.jpg": 12036,
	"./experiences/wedding/ptoVallarta.webp": 2456,
	"./experiences/wedding/terraza-lgbt.JPG": 4576,
	"./footer/atlas.png": 50716,
	"./footer/icono.png": 8184,
	"./geoparques/cinta.jpg": 69772,
	"./geoparques/coahuila/kayak-muzquiz.jpg": 24756,
	"./geoparques/coahuila/las-ventanas-muzquiz.jpeg": 81936,
	"./geoparques/coahuila/melchor-muzquiz-entrada.jpeg": 59620,
	"./geoparques/coahuila/muzquiz-las-ventanas.jpeg": 78304,
	"./geoparques/coahuila/sta-rosa-de-lima-muzquiz.jpg": 43900,
	"./geoparques/descargar.jpg": 20040,
	"./geoparques/dos-corazones.jpg": 26868,
	"./geoparques/flora-muzquiz.jpg": 42468,
	"./geoparques/hidalgo/el-cedral-mineral-del-chico.jpg": 22552,
	"./geoparques/hidalgo/pena-del-aire-huasca.JPG": 42000,
	"./geoparques/hidalgo/prismas-basalticos-huasca.jpg": 9206,
	"./geoparques/muzquiz-las-ventanas.jpeg": 54572,
	"./geoparques/oaxaca/Geositio-las-conchas.jpg": 80468,
	"./geoparques/oaxaca/Visitas-Guiadas-al-Geoparque.jpg": 69476,
	"./geoparques/oaxaca/Vista-Panoramica-del-Geoparque-Mixteca-Alta-2.jpg": 99527,
	"./geoparques/piedra-del-comal.jpg": 26456,
	"./geoparques/pilar_1.svg": 93551,
	"./geoparques/pilar_2.svg": 41403,
	"./geoparques/pilar_3.svg": 12936,
	"./guiasTuristicas/acapulco.png": 41160,
	"./guiasTuristicas/campeche.png": 67152,
	"./guiasTuristicas/cancun.png": 78152,
	"./guiasTuristicas/cdmx.png": 45436,
	"./guiasTuristicas/chiapas.png": 59136,
	"./guiasTuristicas/costamaya.png": 62344,
	"./guiasTuristicas/guadalajara.png": 54276,
	"./guiasTuristicas/guandajuato.png": 32916,
	"./guiasTuristicas/guiasTuristicasBanner.png": 63748,
	"./guiasTuristicas/guiasTuristicasBanner.webp": 82984,
	"./guiasTuristicas/image 54.png": 85380,
	"./guiasTuristicas/image 55.png": 61236,
	"./guiasTuristicas/image 56.png": 239,
	"./guiasTuristicas/image 57.png": 62704,
	"./guiasTuristicas/image 58.png": 82432,
	"./guiasTuristicas/image 59.png": 84872,
	"./guiasTuristicas/image 60.png": 93304,
	"./guiasTuristicas/image 61.png": 24628,
	"./guiasTuristicas/image 62.png": 70796,
	"./guiasTuristicas/image 65.png": 32468,
	"./guiasTuristicas/image 66.png": 34592,
	"./guiasTuristicas/image 67.png": 8548,
	"./guiasTuristicas/image 68.png": 15956,
	"./guiasTuristicas/image 69.png": 94768,
	"./guiasTuristicas/image 70.png": 83765,
	"./guiasTuristicas/image 72.png": 93340,
	"./guiasTuristicas/image 73.png": 58196,
	"./guiasTuristicas/islacaribe.png": 60132,
	"./guiasTuristicas/islacozumel.png": 45664,
	"./guiasTuristicas/ixtapa.png": 2188,
	"./guiasTuristicas/michoaca.png": 53804,
	"./guiasTuristicas/nayarit.png": 63956,
	"./guiasTuristicas/oaxaca.png": 71492,
	"./guiasTuristicas/puebla.png": 27744,
	"./guiasTuristicas/riv-maya.png": 94388,
	"./guiasTuristicas/tren maya 3.png": 59696,
	"./guiasTuristicas/yucatan.png": 9608,
	"./guiasTuristicas/zacatecas.png": 84492,
	"./header/1MOR-Tepoztlan-ExConventoNatividad-PuebloMagico-GerardoJuarez-4858_2-_1__11zon.webp": 22856,
	"./header/1PUEBLOS-MAGICOS.webp": 76360,
	"./header/AguascalientesRutadelVino.webp": 81308,
	"./header/AxeCeremonia.png": 37720,
	"./header/BCS_tiburonballena.webp": 19240,
	"./header/BCStiburonballena.webp": 18176,
	"./header/CALENDARIO.webp": 72424,
	"./header/CAM_calakmul53.webp": 64384,
	"./header/CHIH_creel47.webp": 77480,
	"./header/CN.svg": 66240,
	"./header/Chiapas-agua_azul-01.webp": 56016,
	"./header/CiudaddeMexico_Portada.webp": 41520,
	"./header/DE.svg": 75888,
	"./header/DESTINODELMES.webp": 83944,
	"./header/DF_Bellas_artes_04.webp": 7904,
	"./header/Dgo_Ciudad_Durango421.webp": 36872,
	"./header/EN.svg": 82852,
	"./header/ES.svg": 59300,
	"./header/FERIASM.png": 74048,
	"./header/FR.svg": 41209,
	"./header/FestivalCine.png": 15952,
	"./header/Fondoamarrillo.webp": 40024,
	"./header/Fondorosa.webp": 61052,
	"./header/GTO_guanajuato_338.webp": 72656,
	"./header/Hgo_tula_003.webp": 65502,
	"./header/IT.svg": 34132,
	"./header/JP.svg": 47684,
	"./header/MOR-Tepoztlan-ExConventoNatividad-PuebloMagico-GerardoJuarez-4858_2-_1__11zon.webp": 69728,
	"./header/MOR_Tepoztlan_HotelDosPiedras_LGBT-33.webp": 52192,
	"./header/MOR_xochicalco_t_156-_1__11zon.webp": 19120,
	"./header/MacroplazaMonterreyNuevoLeon.webp": 25152,
	"./header/MartesDePrimavera.jpeg": 52360,
	"./header/Mole-Poblano.webp": 8310,
	"./header/NAY_RinconDeGuayabitos_Playas_0529.webp": 15296,
	"./header/NAY_sanblas_8.webp": 61564,
	"./header/NUEVOSNOMBRAMIENTOSPUEBLOSMAGICOS.webp": 80592,
	"./header/NoviosGuerrero.webp": 4376,
	"./header/Nuevo-Vallarta.webp": 69320,
	"./header/PGARiveraM.png": 12904,
	"./header/PT.svg": 5084,
	"./header/PUEBLOS-MAGICOS.webp": 82584,
	"./header/Pareja-Queretaro-3.webp": 99944,
	"./header/PremierPadel.png": 5452,
	"./header/Qroo_cancun_playa108.webp": 55880,
	"./header/QuintanaRoo.webp": 76488,
	"./header/SERIEMLB.png": 32680,
	"./header/SIN_guanacoa_257.webp": 41488,
	"./header/SON_SanCarlos_Mirador-138_11zon.webp": 2494,
	"./header/San-Pancho.webp": 89236,
	"./header/TRAVESIA-3(1).webp": 1494,
	"./header/VIVELATINO.png": 11608,
	"./header/WhatsApp-Image-2023-07-27-at-1.06.03-AM.webp": 93572,
	"./header/YUC_Cusaman_Cenotes152.webp": 5082,
	"./header/YUC_Hacienda_Ochil139.webp": 86680,
	"./header/YUC_Valladolid18-2.webp": 88,
	"./header/ZARAPE.webp": 88450,
	"./header/abierto-tenis-aca.jpeg": 8050,
	"./header/acapulco.jpg": 40036,
	"./header/acapulco_logo.png": 97916,
	"./header/acapulco_logo.svg": 60288,
	"./header/banner_muertos.jpg": 17332,
	"./header/blog.webp": 43608,
	"./header/bloghome.webp": 98784,
	"./header/carnaval.jpg": 20572,
	"./header/destinodelmescdmx.webp": 51088,
	"./header/dia-de-muertos (1).webp": 84214,
	"./header/dia-de-muertos.png": 14096,
	"./header/dos-corazones.jpg": 42376,
	"./header/enoturismo1.jpg": 54660,
	"./header/f1evento.webp": 69076,
	"./header/fondo_muertos.jpg": 11327,
	"./header/fsanmarcos.png": 83220,
	"./header/homeSlide1.jpg": 98716,
	"./header/homeSlide2.jpg": 61548,
	"./header/homeSlide3.jpg": 14372,
	"./header/homeSlide4.jpg": 75708,
	"./header/hotel-tren-maya.png": 25948,
	"./header/islas-marias.png": 47908,
	"./header/liston-azul.webp": 92562,
	"./header/logo.png": 67716,
	"./header/menu-open.svg": 38940,
	"./header/mexicana.jpg": 19564,
	"./header/mexicoatravesdelosanos.webp": 6492,
	"./header/muertos_evento_4.jpg": 12312,
	"./header/navidad-mexico.webp": 85120,
	"./header/oaxacaguelaguetza.webp": 26824,
	"./header/piramide.webp": 35288,
	"./header/semana_santa.jpg": 36340,
	"./header/tecate.png": 82436,
	"./header/textura-menu.png": 43584,
	"./header/tianguis.jpeg": 61504,
	"./header/tren-maya-cover.jpg": 25860,
	"./header/trenMaya.webp": 35544,
	"./header/tturistico.png": 50404,
	"./header/turismoLogo.png": 46484,
	"./header/videos.webp": 29032,
	"./header/videos360.png": 45680,
	"./icons/bus-bg.png": 38796,
	"./icons/food-bg.png": 6852,
	"./icons/plane-svg.svg": 20159,
	"./icons/stones-floor.png": 88348,
	"./interactiveDayDead/BASE3_LARGA.svg": 29540,
	"./interactiveDayDead/CALAVERITA.svg": 60200,
	"./interactiveDayDead/CINTA1.svg": 75252,
	"./interactiveDayDead/COMIDA1.svg": 15804,
	"./interactiveDayDead/COPAL.svg": 67624,
	"./interactiveDayDead/CRANEO_CENTRO.svg": 7079,
	"./interactiveDayDead/FLOR1.svg": 91856,
	"./interactiveDayDead/FLORES3_IZQ.svg": 71048,
	"./interactiveDayDead/FLOR_DERECHA1.svg": 46340,
	"./interactiveDayDead/FONDO.svg": 93720,
	"./interactiveDayDead/FONDO_AZUL.svg": 23436,
	"./interactiveDayDead/JARRITO.svg": 40660,
	"./interactiveDayDead/LETRERO1.svg": 95796,
	"./interactiveDayDead/LETREROS2.svg": 90980,
	"./interactiveDayDead/PAN_DE_MUERTO1.svg": 5412,
	"./interactiveDayDead/PAN_DE_MUERTO2.svg": 53064,
	"./interactiveDayDead/PAPEL_PICADO.svg": 8728,
	"./interactiveDayDead/PAPEL_PICADO2.svg": 27560,
	"./interactiveDayDead/RETRATO.svg": 81736,
	"./interactiveDayDead/TEQUILA.svg": 43680,
	"./interactiveDayDead/VASO_DE_AGUA.svg": 90988,
	"./interactiveDayDead/VELAS.svg": 62143,
	"./interactiveDayDead/VELAS2.svg": 60876,
	"./magicTowns/8.jpg": 98260,
	"./magicTowns/ACAXOCHITLan.png": 98052,
	"./magicTowns/ANGANGUEO.jpg": 10836,
	"./magicTowns/Ahuacatlannay.JPG": 94456,
	"./magicTowns/Ajijic jal.png": 54764,
	"./magicTowns/ArteagaCoahuila.jpeg": 71740,
	"./magicTowns/BC_TECATE.jpg": 15668,
	"./magicTowns/COTIJA.png": 28316,
	"./magicTowns/CUITZEO DEL PORVENIR.jpg": 36948,
	"./magicTowns/CalzadaDeLasReinasEnTalpa.webp": 87904,
	"./magicTowns/Canopy.jpg": 78088,
	"./magicTowns/CentroHistorico.webp": 68024,
	"./magicTowns/CerrodelaBufa5.webp": 58256,
	"./magicTowns/CholulaPuebla.jpg": 66244,
	"./magicTowns/Coculajal.jpeg": 93220,
	"./magicTowns/Compostelan_185.jpg": 9724,
	"./magicTowns/DAN_4079.jpg": 8108,
	"./magicTowns/DJI_0030.JPG": 42104,
	"./magicTowns/DSC09267scaled.webp": 8778,
	"./magicTowns/DSC09734.jpg": 70256,
	"./magicTowns/DelfinesIslaAguada.webp": 65824,
	"./magicTowns/ELORO.jpg": 11300,
	"./magicTowns/ElFuerteSinaloa.jpeg": 89932,
	"./magicTowns/GEMD_OAX_CAPULALPAM.webp": 22414,
	"./magicTowns/GENERAL ZARAGOZA.jpg": 50672,
	"./magicTowns/GENERALZARAGOZAplazaprincipal.png": 99616,
	"./magicTowns/HUASCAHIDALGO.jpg": 62132,
	"./magicTowns/HUICHAPANHIDALGO.jpg": 16876,
	"./magicTowns/HuamantlaTlaxcala.jpg": 49088,
	"./magicTowns/HuautlaJimenez.jpg": 23312,
	"./magicTowns/IXCATEOPAN.jpg": 85567,
	"./magicTowns/IXTAPAN.jpg": 47844,
	"./magicTowns/Insignia Tern.png": 52568,
	"./magicTowns/IslaMujeresQuintanaRoo.jpg": 19984,
	"./magicTowns/JALISCO_MAZAMITLA.webp": 55560,
	"./magicTowns/JAL_MASCOTA.webp": 17112,
	"./magicTowns/JiquilpanMICHO.png": 432,
	"./magicTowns/LaJima1.webp": 90244,
	"./magicTowns/MALINALCO.jpg": 23772,
	"./magicTowns/METEPEC.jpg": 22736,
	"./magicTowns/MINERAL DEL CHICO.jpg": 82152,
	"./magicTowns/MUZQUIZ.jpg": 23672,
	"./magicTowns/MetztitlanHIDALGO.jpg": 61028,
	"./magicTowns/Mineralguana.webp": 29512,
	"./magicTowns/Miradorsantiago.webp": 94448,
	"./magicTowns/MuralesdeAjijic.webp": 28666,
	"./magicTowns/OTUMBA.jpg": 57324,
	"./magicTowns/Ocozocoautla.jpg": 6020,
	"./magicTowns/PARACHOMICHO.jpg": 94084,
	"./magicTowns/PalenqueChiapas.jpg": 76402,
	"./magicTowns/Pattzcuaro.jpg": 84755,
	"./magicTowns/Puente.webp": 62090,
	"./magicTowns/REAL DEL MONTE  HIDALGO.jpg": 61940,
	"./magicTowns/REAL_ASIENTOS.webp": 88144,
	"./magicTowns/SAN PEDRO Y SAN PABLO TEPOSCOLULAOAXACA.jpg": 55196,
	"./magicTowns/SIN_guanacoa_257.webp": 14854,
	"./magicTowns/Salvatierra.webp": 39632,
	"./magicTowns/TALPUJAHUA.jpg": 84996,
	"./magicTowns/TAPALPA_ANTIGUO.webp": 50044,
	"./magicTowns/TAXCO.jpg": 70412,
	"./magicTowns/TECOZAUTLA HIDALGO.jpg": 90360,
	"./magicTowns/TLALTIZAPaN DE ZAPATA.jpg": 32256,
	"./magicTowns/TONATICO.jpg": 87148,
	"./magicTowns/TZINTZUNTZAN.png": 32732,
	"./magicTowns/Tacambaro.jpg": 28972,
	"./magicTowns/Tepozmol.webp": 59224,
	"./magicTowns/Tlaquepaque.jpg": 97216,
	"./magicTowns/Tlayacapanmor.png": 71592,
	"./magicTowns/Todos_SantosBC.webp": 33904,
	"./magicTowns/VILLA DEL CARBOoN.jpg": 48348,
	"./magicTowns/VilladelCarbonEstadodeMexico.png": 53928,
	"./magicTowns/XOCHITEPEC.jpg": 1224,
	"./magicTowns/ZEMPOALA HIDALGO.jpg": 89892,
	"./magicTowns/ZIHUATANEJO.jpg": 82748,
	"./magicTowns/ZIMAPANHIDALGO.jpg": 6556,
	"./magicTowns/aculco.jpg": 63700,
	"./magicTowns/batopilas.jpg": 70368,
	"./magicTowns/bustamante.jpg": 65344,
	"./magicTowns/calvillo.webp": 53464,
	"./magicTowns/candela.jpg": 56168,
	"./magicTowns/candelaria_campeche.jpg": 92484,
	"./magicTowns/casagrande.webp": 59688,
	"./magicTowns/cepedacoa.jpg": 53432,
	"./magicTowns/coinala.webp": 35022,
	"./magicTowns/comala.jpg": 66300,
	"./magicTowns/comitan.webp": 42064,
	"./magicTowns/comofortguana.webp": 42856,
	"./magicTowns/corzo.webp": 5872,
	"./magicTowns/creel.jpg": 600,
	"./magicTowns/cuatrocienegas.jpg": 34020,
	"./magicTowns/doloresguanajuato.jpg": 54335,
	"./magicTowns/durango1.jpg": 97328,
	"./magicTowns/durango2.jpg": 77608,
	"./magicTowns/guachochi.jpeg": 63712,
	"./magicTowns/guanajuato-jalpa.jpg": 5212,
	"./magicTowns/guerreroCOa.jpg": 50932,
	"./magicTowns/jilotepec.png": 10480,
	"./magicTowns/lagos_moreno.jpeg": 88012,
	"./magicTowns/loretobcs.webp": 80448,
	"./magicTowns/lugarescdmx.jpeg": 95012,
	"./magicTowns/mazunte.jpeg": 70844,
	"./magicTowns/mitla_IG.webp": 11688,
	"./magicTowns/pabellon_hidalgo.png": 56544,
	"./magicTowns/palizada_campeche.jpg": 91724,
	"./magicTowns/parrascoa.webp": 88400,
	"./magicTowns/pescamexcaltitan.webp": 53856,
	"./magicTowns/pueblos_magicos-logo.png": 16544,
	"./magicTowns/rosaliasbcs.JPG": 2312,
	"./magicTowns/sancristobal.jpeg": 47216,
	"./magicTowns/sansebastianjal.webp": 6004,
	"./magicTowns/santa clara del cobre.jpg": 55536,
	"./magicTowns/santuariojuquila.webp": 24872,
	"./magicTowns/sayula_19.png": 34204,
	"./magicTowns/sayulita.webp": 87816,
	"./magicTowns/temacapulin.webp": 52872,
	"./magicTowns/tepozotlan.jpeg": 86384,
	"./magicTowns/tequilajalisco.jpg": 64252,
	"./magicTowns/tunel-aguascalientes.jpg": 57868,
	"./magicTowns/vallebravo.jpg": 25900,
	"./magicTowns/viezcacoa.jpg": 29280,
	"./magicTowns/villa-del-carbon.jpg": 1063,
	"./magicTowns/yuriria.webp": 78408,
	"./mariaIslands/IslasMarias.webp": 40192,
	"./mariaIslands/islasmarias2.webp": 71440,
	"./mariaIslands/islasmarias3.webp": 81408,
	"./mariaIslands/islasmarias4.webp": 53800,
	"./mariaIslands/islasmarias5.webp": 36904,
	"./mariaIslands/islasmarias6.webp": 96448,
	"./mariaIslands/islasmarias7.webp": 84528,
	"./mariaIslands/islasmarias8.webp": 29854,
	"./menu/acapulco-B.png": 18784,
	"./menu/acapulco-CLR.png": 67724,
	"./menu/acapulco-N.png": 32020,
	"./menu/angelesverdes-B.png": 39164,
	"./menu/angelesverdes-CLR.png": 22288,
	"./menu/angelesverdes-N.png": 94924,
	"./menu/atlasturistico-B.png": 66292,
	"./menu/atlasturistico-CLR.png": 21692,
	"./menu/atlasturistico-N.png": 24996,
	"./menu/calendario-B.png": 85292,
	"./menu/calendario-CLR.png": 54724,
	"./menu/calendario-N.png": 19524,
	"./menu/carteleracultural-B.png": 63055,
	"./menu/carteleracultural-CLR.png": 39996,
	"./menu/doll.png": 50072,
	"./menu/experiencias-B.png": 29044,
	"./menu/experiencias-CLR.png": 75004,
	"./menu/experiencias-N.png": 16840,
	"./menu/facebook-CLR.png": 924,
	"./menu/gafsacomm-B.png": 18996,
	"./menu/gafsacomm-CLR.png": 73424,
	"./menu/gafsacomm-N.png": 60404,
	"./menu/guiaturistica-B.png": 93376,
	"./menu/guiaturistica-CLR.png": 56400,
	"./menu/guiaturistica-N.png": 84196,
	"./menu/instagram-CLR.png": 24984,
	"./menu/islamaria-B.png": 95508,
	"./menu/islamaria-CLR.png": 15076,
	"./menu/islamaria-N.png": 58036,
	"./menu/mexicana-B.png": 26132,
	"./menu/mexicana-CLR.png": 23340,
	"./menu/mexicana-N.png": 70188,
	"./menu/pueblosmagicos-B.png": 48108,
	"./menu/pueblosmagicos-CLR.png": 29092,
	"./menu/pueblosmagicos-clr.svg": 97732,
	"./menu/reproduccion-B.png": 62847,
	"./menu/reproduccion-CLR.png": 98700,
	"./menu/reproduccion-N.png": 85496,
	"./menu/rnt-B.png": 62728,
	"./menu/rnt-CLR.png": 19948,
	"./menu/rnt-N.png": 99220,
	"./menu/tiktok-CLR.png": 23444,
	"./menu/trenmaya-B.png": 86412,
	"./menu/trenmaya-CLR.png": 27144,
	"./menu/trenmaya-N.png": 63432,
	"./menu/turismoxico-B.png": 47596,
	"./menu/turismoxico-CLR.png": 4860,
	"./menu/turismoxico-N.png": 83683,
	"./menu/x-CLR.png": 10199,
	"./mice/collage/1.jpg": 68596,
	"./mice/collage/10.jpg": 52076,
	"./mice/collage/2.jpg": 92828,
	"./mice/collage/3.jpg": 82351,
	"./mice/collage/4.jpg": 17320,
	"./mice/collage/5.jpg": 30060,
	"./mice/collage/6.jpg": 21828,
	"./mice/collage/7.jpg": 85724,
	"./mice/collage/8.jpg": 86312,
	"./mice/collage/9.jpg": 8375,
	"./mice/collage1.webp": 65484,
	"./mice/collage_1.jpeg": 78996,
	"./mice/collage_2.jpeg": 33915,
	"./mice/collage_3.jpeg": 68016,
	"./mice/collage_4.jpeg": 18988,
	"./mice/collage_5.jpeg": 57928,
	"./mice/collage_6.jpeg": 3008,
	"./mice/collage_7.jpeg": 72952,
	"./mice/collage_8.jpeg": 24648,
	"./mice/collage_9.jpeg": 69732,
	"./mice/congresos.svg": 24952,
	"./mice/congresos_purple.svg": 1096,
	"./mice/convenciones.svg": 89680,
	"./mice/convenciones_purple.svg": 72068,
	"./mice/ferias.svg": 84460,
	"./mice/ferias_purple.svg": 26388,
	"./mice/imgprotagonista.png": 22820,
	"./mice/incentivos.svg": 92280,
	"./mice/incentivos_purple.svg": 14260,
	"./mice/mapa.svg": 28636,
	"./mice/otras_reuniones.svg": 45928,
	"./mice/otras_reuniones_purple.svg": 7380,
	"./mice/reuniones1.jpg": 87860,
	"./mice/reuniones1.png": 21424,
	"./mice/reuniones2.jpg": 40804,
	"./mice/reuniones2.png": 75980,
	"./mice/reuniones3.jpg": 23996,
	"./mice/reuniones3.png": 46200,
	"./mice/reuniones4.jpg": 36584,
	"./mice/reuniones4.png": 97660,
	"./mice/reuniones5.jpg": 3800,
	"./mice/reuniones5.png": 30920,
	"./muertos/CDMX-zocalo.jpg": 66556,
	"./muertos/Chignahuapan.jpg": 22100,
	"./muertos/Cuetzalan-Puebla.jpg": 86496,
	"./muertos/Isla-de-Janitzio-Michoacan.jpg": 52096,
	"./muertos/San-Andres-Mixquic-CDMX.jpg": 57840,
	"./muertos/Tzintzuntzana-Michoacan.jpg": 36300,
	"./muertos/Xochimilco.jpg": 8324,
	"./muertos/aguascalientes.jpg": 59624,
	"./muertos/footer_muertos.jpg": 49404,
	"./muertos/hero_muertos.jpg": 98236,
	"./muertos/huatla-oaxaca-huehuetones-en-cdmx_optimized.jpg": 12084,
	"./muertos/muertos_altar.jpg": 57636,
	"./muertos/muertos_altar_2.jpg": 19940,
	"./muertos/muertos_carrusel.jpg": 31480,
	"./muertos/muertos_carrusel_1.jpg": 484,
	"./muertos/muertos_carrusel_2.jpg": 78372,
	"./muertos/muertos_carrusel_3.jpg": 88120,
	"./muertos/muertos_carrusel_4.jpg": 38944,
	"./muertos/muertos_carrusel_5.jpg": 44950,
	"./muertos/muertos_evento.jpg": 38647,
	"./muertos/muertos_evento_1.jpg": 48068,
	"./muertos/muertos_evento_2.jpg": 31052,
	"./muertos/muertos_evento_3.jpg": 74028,
	"./muertos/muertos_evento_4.jpg": 28648,
	"./muertos/muertos_evento_5.jpg": 46128,
	"./muertos/muertos_evento_6.jpg": 43884,
	"./muertos/muertos_evento_7.jpg": 10032,
	"./muertos/real-del-monte.png": 34412,
	"./muertos/teotihuacan.jpg": 54528,
	"./muertos/tlaxco-tlaxcala.jpg": 86540,
	"./newBlog/Acapulco.webp": 4440,
	"./newBlog/AcapulcoCostera.webp": 54328,
	"./newBlog/Bacalar.webp": 60000,
	"./newBlog/CallejonesGuanajuato-min.webp": 95410,
	"./newBlog/Cosala.webp": 27056,
	"./newBlog/Cozumel1.jpeg": 2416,
	"./newBlog/CozumelBicicleta.jpeg": 10520,
	"./newBlog/CozumelBuzo.jpeg": 11716,
	"./newBlog/CozumelBuzo.webp": 6728,
	"./newBlog/DIA-DE-MUERTOS-INFLUENCER_05.jpeg": 35339,
	"./newBlog/DoloresHidalgo.webp": 944,
	"./newBlog/Ecoturismo-tren-maya-blog1.jpg": 21276,
	"./newBlog/ElFuerteSinaloa.webp": 73664,
	"./newBlog/EsferaArtesanal.jpg": 73036,
	"./newBlog/EsferasChignahuapan.jpg": 55068,
	"./newBlog/EsferasVidrioSoplado.jpg": 28020,
	"./newBlog/Guanajuato.webp": 29992,
	"./newBlog/Huasca.webp": 71808,
	"./newBlog/LaQuebradaAcapulco.webp": 43120,
	"./newBlog/Mazatlan.webp": 77120,
	"./newBlog/Mineraldelchico.webp": 38296,
	"./newBlog/Mixquic.webp": 13156,
	"./newBlog/Mocorito_.webp": 50822,
	"./newBlog/Nievchepe-Blog1.png": 20368,
	"./newBlog/PuertoMarques.webp": 98492,
	"./newBlog/Realdelmonte.webp": 66224,
	"./newBlog/SanMigueldeAllende.webp": 46688,
	"./newBlog/Tren-maya-blog1.png": 78488,
	"./newBlog/Villailuminada.jpg": 94228,
	"./newBlog/acapulco-fin-de-anio.jpeg": 44096,
	"./newBlog/acapulco_cover.jpg": 84852,
	"./newBlog/alexander_von_humboldt.jpg": 24800,
	"./newBlog/alumbrado-cdmx.png": 80152,
	"./newBlog/atilxco-puebla.jpg": 34320,
	"./newBlog/badiraguato.webp": 70500,
	"./newBlog/bahia-cacaluta.jpg": 96500,
	"./newBlog/bahia-chahue.png": 39180,
	"./newBlog/bahia-maguey.png": 86656,
	"./newBlog/bahia-organo.png": 44140,
	"./newBlog/bahia-san-agustin.png": 95352,
	"./newBlog/bahia-santa-cruz.jpg": 96344,
	"./newBlog/bahia-tangolunda.png": 27788,
	"./newBlog/bahias-huatulco.png": 61888,
	"./newBlog/balneario_chignahuapan.jpg": 66148,
	"./newBlog/barbies-navidenias.png": 76968,
	"./newBlog/cascada-el-salto - copia.jpg": 70144,
	"./newBlog/cascada-el-salto.jpg": 75088,
	"./newBlog/cascanueces.jpg": 74440,
	"./newBlog/centro-historico-de-culiacan-centro.webp": 272,
	"./newBlog/chignahuapan_iglesia.png": 32180,
	"./newBlog/chignahuapan_portada2.jpg": 44608,
	"./newBlog/convento_acolman.png": 9756,
	"./newBlog/coyuca.png": 89284,
	"./newBlog/cozumel.webp": 0,
	"./newBlog/desfila-villa-iluminada.jpg": 78516,
	"./newBlog/destinos.jpg": 44500,
	"./newBlog/dia-de-muertos.webp": 63610,
	"./newBlog/diademuertos.webp": 47456,
	"./newBlog/el-chepeblog1.jpg": 89316,
	"./newBlog/esferas_Chignahuapan.png": 24036,
	"./newBlog/experiencias.jpg": 9052,
	"./newBlog/fabrica-de-santa.jpg": 68260,
	"./newBlog/gastronomia-mexicana.jpg": 2120,
	"./newBlog/gnp-cover.jpg": 78572,
	"./newBlog/heroSlide_1.jpg": 42728,
	"./newBlog/heroSlide_2.jpg": 49516,
	"./newBlog/huascaDeOcampo.webp": 35744,
	"./newBlog/janitzio.webp": 96624,
	"./newBlog/la-quebrada.jpg": 56788,
	"./newBlog/la-redonda.jpg": 51404,
	"./newBlog/la-redonda.webp": 19936,
	"./newBlog/laguna-pie-de-la-cuesta.png": 36060,
	"./newBlog/letras_acolman.jpg": 44556,
	"./newBlog/manoEsferas.png": 97888,
	"./newBlog/monterrey.jpg": 70280,
	"./newBlog/navidad_cdmx.jpg": 56532,
	"./newBlog/pichilingue.jpg": 49868,
	"./newBlog/pie-dela-cuesta-laguna.png": 88268,
	"./newBlog/pie-dela-cuesta.png": 8444,
	"./newBlog/pinatas_mexicanas.jpg": 54848,
	"./newBlog/piniata.webp": 50660,
	"./newBlog/piniatas.jpg": 32608,
	"./newBlog/planea-tu-viaje.jpg": 52072,
	"./newBlog/puerto-marques.jpg": 51316,
	"./newBlog/puerto_marques_1.jpeg": 77976,
	"./newBlog/puerto_marques_2.jpeg": 15412,
	"./newBlog/puerto_marques_3.jpeg": 89920,
	"./newBlog/puerto_marques_4.jpeg": 88972,
	"./newBlog/puerto_marques_5.jpeg": 56312,
	"./newBlog/rambo2.jpg": 72844,
	"./newBlog/tren-el-chepe-blog1.png": 84312,
	"./newBlog/tren-maya-turismo.jpg": 28160,
	"./newBlog/villa-iluminada-atlixco.jpg": 64060,
	"./newBlog/villa-navidenia-gam.jpg": 68124,
	"./newBlog/vino-mexicano.jpg": 14800,
	"./promotion/Banner_TT_Aventura_En.jpg": 60472,
	"./promotion/Banner_TT_Aventura_Es.jpg": 76396,
	"./promotion/GT-BANNER.png": 46035,
	"./promotion/MartesDePrimavera.jpeg": 52376,
	"./promotion/PuntoMexico1.jpeg": 336,
	"./promotion/PuntoMexico2.jpeg": 25520,
	"./promotion/PuntoMexico3.jpeg": 53652,
	"./promotion/XICO-CLR-BNN.png": 20588,
	"./promotion/axe-ceremonia.png": 92704,
	"./promotion/carnaval.jpg": 9708,
	"./promotion/fsanmarcos.png": 39488,
	"./promotion/mexico360.png": 91528,
	"./promotion/prensa.jpg": 53463,
	"./promotion/separador.png": 4588,
	"./promotion/separador2.png": 4584,
	"./promotion/tecate.png": 90792,
	"./promotion/tianguis.jpeg": 17296,
	"./promotion/tturistico.png": 36608,
	"./pueblos-magicos/Huamantla.png": 79548,
	"./pueblos-magicos/Ixtenco.png": 49844,
	"./pueblos-magicos/Tlaxco.png": 52884,
	"./pueblos-magicos/aeropuerto.svg": 3780,
	"./pueblos-magicos/barrios.svg": 16268,
	"./pueblos-magicos/calvillo.PNG": 20892,
	"./pueblos-magicos/gastronomia/huamantla/Huamantla1.jpg": 24868,
	"./pueblos-magicos/gastronomia/huamantla/Huamantla2.jpg": 40380,
	"./pueblos-magicos/gastronomia/huamantla/Huamantla3.jpg": 5888,
	"./pueblos-magicos/gastronomia/huamantla/Huamantla4.jpg": 53860,
	"./pueblos-magicos/gastronomia/ixtenco/Ixtenco1.jpg": 94712,
	"./pueblos-magicos/gastronomia/ixtenco/Ixtenco2.jpg": 62528,
	"./pueblos-magicos/gastronomia/ixtenco/Ixtenco3.jpg": 84784,
	"./pueblos-magicos/gastronomia/ixtenco/Ixtenco4.jpg": 65815,
	"./pueblos-magicos/gastronomia/tlaxco/Tlaxco1.jpg": 77571,
	"./pueblos-magicos/gastronomia/tlaxco/Tlaxco2.jpg": 73384,
	"./pueblos-magicos/gastronomia/tlaxco/Tlaxco3.jpg": 88416,
	"./pueblos-magicos/gastronomia/tlaxco/Tlaxco4.jpg": 12964,
	"./pueblos-magicos/islas.svg": 95332,
	"./pueblos-magicos/logo_ciudades_pin.svg": 5268,
	"./pueblos-magicos/logo_pin.svg": 19680,
	"./pueblos-magicos/maya.svg": 80060,
	"./pueblos-magicos/palmera.png": 46275,
	"./pueblos-magicos/piramide-maya.png": 74764,
	"./pueblos-magicos/sitios.svg": 33812,
	"./pueblos-magicos/tren-maya.svg": 19076,
	"./pueblos-magicos/tren.png": 72772,
	"./pueblos-magicos/volcan.png": 2916,
	"./rss/arrow-left.svg": 94368,
	"./rss/arrow-link.svg": 29956,
	"./rss/arrow-right.svg": 94358,
	"./rss/arrow-up.svg": 43296,
	"./rss/facebook-N.png": 74396,
	"./rss/facebook.png": 32055,
	"./rss/facebook.svg": 9876,
	"./rss/instagram-N.png": 22432,
	"./rss/instagram.png": 30868,
	"./rss/instagram.svg": 84756,
	"./rss/tiktok-N.png": 70376,
	"./rss/tiktok.png": 91764,
	"./rss/tiktok.svg": 1844,
	"./rss/x-N.png": 82560,
	"./rss/x.png": 74692,
	"./rss/x_logo.svg": 4660,
	"./subscribe/download.png": 19092,
	"./trenMaya/BacalarQuintanaRoo.webp": 99040,
	"./trenMaya/CalkiniCampeche.webp": 74448,
	"./trenMaya/ChichenItzaYucatan.webp": 54016,
	"./trenMaya/IzamalYucatanpan.webp": 18278,
	"./trenMaya/PalenqueChiapas.webp": 23448,
	"./trenMaya/Palenque_94.webp": 87616,
	"./trenMaya/PlayaDelCarmenQuintanaRoo.webp": 49064,
	"./trenMaya/PuertoMorelosQuintanaRoo.webp": 81776,
	"./trenMaya/PuntoDeVenta.jpg": 1892,
	"./trenMaya/TulumQuintanaRoo.webp": 76672,
	"./trenMaya/cancun-quintana-roo.webp": 22852,
	"./trenMaya/estacion.webp": 98768,
	"./wines/8_VINOS_DE_COAHUILA.webp": 87228,
	"./wines/BCN_valle_guadalupe_22.webp": 58566,
	"./wines/Region_vinos_Cava_Freixenetqueretaro.webp": 4840,
	"./wines/uvabajacalifornia.webp": 78296,
	"./wines/uvasaguascalientes.webp": 71612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;